<template>
  <v-container fluid>
    <v-card class="pa-6">
      <v-card-title class="text-h6">New Trademark Matter</v-card-title>
      <v-card-text v-if="showaddItem.tm_type == 0">
        <v-row>
          <v-col cols="12" sm="7" md="7" style="margin-top: 14px">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <h3><span class="red--text">* </span>Object Type</h3>
                <v-autocomplete v-model="showaddItem.tm_type" :items="objecttype_list" item-text="objecttype_code"
                  item-value="objecttype_id" outlined @change="onSelectObjiTypeChange" dense></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="5" md="5" />
        </v-row>
      </v-card-text>
      <v-card-text v-else>
        <v-row>
          <v-col cols="12" sm="7" md="7" style="margin-top: 14px">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <h3><span class="red--text">* </span>Object Type</h3>
                <v-autocomplete v-model="showaddItem.tm_type" :items="objecttype_list" item-text="objecttype_code"
                  item-value="objecttype_id" outlined @change="onSelectObjiTypeChange" dense></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <h3>Country</h3>
                <!-- <v-text-field
                        v-model="showaddItem.country"
                        outlined
                        dense
                        ></v-text-field> -->
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    showaddItem.country = 0;
                  })
                  " v-model="showaddItem.country" :items="country_list" item-text="enname" item-value="enname" outlined
                  @change="onSelectCountryChange(showaddItem.country)" dense></v-autocomplete>
              </v-col>
            </v-row>
            <div v-if="showFiling">
              <v-row>
                <v-col cols="12" sm="8" md="8">
                  <v-row class="mt-h">
                    <v-col cols="12" sm="6" md="6">
                      <h3>Application No.</h3>
                      <v-text-field v-model="showaddItem.app_no" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <h3>Class No.</h3>
                      <v-text-field v-model="showaddItem.class_no" outlined dense></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="6" md="6">
                      <h3>IR No.</h3>
                      <v-text-field v-model="showaddItem.ir_no" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <h3>Application Date</h3>
                      <v-menu v-model="menuaddappdate" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field clearable @click:clear="
                            $nextTick(() => {
                              showaddItem.date_of_application = '';
                              date_of_application = '';
                            })
                            " v-model="showaddItem.date_of_application" persistent-hint hint="Format DD/MM/YYYY"
                            @keydown.enter="
                              Selectchangedate_of_application();
                            date_of_application = parseDate(
                              showaddItem.date_of_application
                            );
                            " @blur="
                              Selectchangedate_of_application();
                            date_of_application = parseDate(
                              showaddItem.date_of_application
                            );
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                        </template>
                        <v-date-picker v-model="date_of_application" @change="Selectchangedate_of_application"
                          @input="menuaddappdate = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="4" md="4">
                      <h3>
                        <span class="red--text">* </span>
                        File No.
                        <span class="red--text">(TM-0000)</span>
                      </h3>
                      <v-text-field v-model="showaddItem.file_no" outlined dense @blur="
                        showaddItem.file_no = showaddItem.file_no
                          .trim()
                          .toUpperCase()
                        "></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="8" md="8">
                      <h3>Trademark Name</h3>
                      <v-text-field v-model="showaddItem.trademark" outlined dense></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pl-6 pr-6">
                  <v-row v-if="previews.length > 0" class="d-flex justify-center align-center"
                    style="text-align: center">
                    <v-carousel v-model="carouselIndex" hide-delimiter-background height="240" show-arrows
                      show-arrows-on-hover hide-delimiters class="carousel-with-shadow">
                      <v-carousel-item v-for="(src, index) in [...previews].reverse()" :key="index">
                        <div class="image-wrapper-carousel">
                          <!-- preview image -->
                          <div class="counter-overlay">
                            {{ index + 1 }} / {{ previews.length }}
                          </div>
                          <img :src="src" class="preview-img-carousel" @click="
                            popuppreviewimage(previews.length - 1 - index)
                            " />

                          <!-- filename overlay -->
                          <div class="filename-overlay-carousel">
                            {{ imagenames[previews.length - 1 - index] }}
                          </div>

                          <!-- delete button -->
                          <v-btn icon color="red" class="delete-btn-carousel" @click.stop="
                            popupdeleteimage(previews.length - 1 - index)
                            ">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </v-carousel-item>
                    </v-carousel>
                  </v-row>
                  <v-row v-else class="no-image-placeholder" style="
                      text-align: center;
                      padding: 20px;
                      border: 1px dashed #ccc;
                      border-radius: 8px;
                    ">
                    <v-icon color="grey" style="font-size: 48px">mdi-image-off</v-icon>
                    <div style="margin-top: 8px; color: grey">No Image</div>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <h3>Trademark Image ( size 592 x 592)</h3>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="12" md="12">
                      <input type="file" accept="image/*" @change="previewImage" class="inputsize" ref="fileimage"
                        style="display: none" multiple />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" class="widthbtnimagefile" @click="$refs.fileimage.click()" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload Image</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row style="margin: 40px 0px 0px 0px">
                <div justify="space-center" class="pt-10 pb-4 pl-8" style="
                    border: 1px solid #ccc;
                    border-radius: 8px;
                    width: 100%;
                  ">
                  <v-row class="mt-h" v-for="(priority, index) in priorityList" :key="index">
                    <v-col cols="12" sm="10" md="10">
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <h3 v-if="index == 0">Priority Number</h3>
                          <v-text-field v-model="priority.number" outlined dense />
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <h3 v-if="index == 0">Priority Date</h3>
                          <v-menu v-model="priority.menu" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field :value="formatDatePriority(priority.date)" persistent-hint
                                hint="Format DD/MM/YYYY" append-icon="mdi-calendar" @keydown.enter="
                                  priority.date = parseDateInputPriority(
                                    priority.date
                                  )
                                  " @blur="
                                    priority.date = parseDateInputPriority(
                                      priority.date
                                    )
                                    " v-bind="attrs" v-on="on" outlined dense clearable></v-text-field>
                            </template>
                            <v-date-picker v-model="priority.date" @input="priority.menu = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <h3 v-if="index == 0">Priority Country</h3>
                          <!-- <v-text-field v-model="priority.country" outlined dense /> -->
                          <v-autocomplete clearable @click:clear="
                            $nextTick(() => {
                              priority.country = 0;
                            })
                            " v-model="priority.country" :items="country_list" item-text="enname" item-value="enname"
                            outlined dense></v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" class="d-flex align-center" style="padding-left: 30px">
                      <v-icon @click="addPriority" class="bt-add" :style="{ marginTop: index > 0 ? '-25px' : 'none' }">
                        mdi-plus
                      </v-icon>
                      <v-icon @click="removePriority(index)" v-if="priorityList.length > 1" class="bt-del"
                        :style="{ marginTop: index > 0 ? '-25px' : 'none' }">
                        mdi-minus
                      </v-icon>
                    </v-col>
                  </v-row>
                </div>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <h3>Publication Date</h3>
                  <v-menu v-model="menupublication" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field clearable @click:clear="
                        $nextTick(() => {
                          showaddItem.date_of_public = '';
                          date_of_public = '';
                        })
                        " v-model="showaddItem.date_of_public" persistent-hint hint="Format DD/MM/YYYY" @keydown.enter="
                          date_of_public = parseDate(showaddItem.date_of_public)
                          " @blur="
                            date_of_public = parseDate(showaddItem.date_of_public)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="date_of_public" @input="menupublication = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row class="mt-h">
                <v-col cols="12" sm="4" md="4">
                  <h3>Registration No.</h3>
                  <v-text-field v-model="showaddItem.regis_no" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <h3>Registration Date</h3>
                  <v-menu width="250px" v-model="menuadd" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field hint="Format DD/MM/YYYY" clearable @click:clear="
                        $nextTick(() => {
                          showaddItem.date_of_regis = '';
                          date_of_regis = '';
                        })
                        " v-model="showaddItem.date_of_regis" persistent-hint @keydown.enter="
                          date_of_regis = parseDate(showaddItem.date_of_regis)
                          " @blur="
                            date_of_regis = parseDate(showaddItem.date_of_regis)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="date_of_regis" @input="menuadd = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row class="mt-h">
                <v-col cols="12" sm="4" md="4">
                  <h3>Issuing Certificate Date</h3>
                  <v-menu v-model="menudate_of_issuing_certificate" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field clearable @click:clear="
                        $nextTick(() => {
                          showaddItem.date_of_issuing_certificate = '';
                          date_of_issuing_certificate = '';
                        })
                        " v-model="showaddItem.date_of_issuing_certificate" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          date_of_issuing_certificate = parseDate(
                            showaddItem.date_of_issuing_certificate
                          )
                          " @blur="
                            date_of_issuing_certificate = parseDate(
                              showaddItem.date_of_issuing_certificate
                            )
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="date_of_issuing_certificate"
                      @input="menudate_of_issuing_certificate = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row class="mt-h">
                <v-col cols="12" sm="4" md="4">
                  <h3>Renewal Not Payable Before</h3>
                  <v-menu v-model="menurenewal_filed" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field clearable @click:clear="
                        $nextTick(() => {
                          showaddItem.date_of_renewal_filed = '';
                          date_of_renewal_filed = '';
                        })
                        " v-model="showaddItem.date_of_renewal_filed" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          date_of_renewal_filed = parseDate(
                            showaddItem.date_of_renewal_filed
                          )
                          " @blur="
                            date_of_renewal_filed = parseDate(
                              showaddItem.date_of_renewal_filed
                            )
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="date_of_renewal_filed" @input="menurenewal_filed = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <h3>Next Renewal Date</h3>
                  <v-menu v-model="menurenewal" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field clearable @click:clear="
                        $nextTick(() => {
                          showaddItem.date_of_renewal = '';
                          date_of_renewal = '';
                        })
                        " v-model="showaddItem.date_of_renewal" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          date_of_renewal = parseDate(
                            showaddItem.date_of_renewal
                          )
                          " @blur="
                            date_of_renewal = parseDate(
                              showaddItem.date_of_renewal
                            )
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="date_of_renewal" @input="onSelectNextRenewalDate"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row class="mt-h">
                <v-col cols="12" sm="4" md="4">
                  <h3>Filing Affidavits Date</h3>
                  <v-menu v-model="menufiling_affidavits" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field clearable @click:clear="
                        $nextTick(() => {
                          showaddItem.dateof_filling_affidavits = '';
                        })
                        " v-model="showaddItem.dateof_filling_affidavits" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          dateof_filling_affidavits = parseDate(
                            showaddItem.dateof_filling_affidavits
                          )
                          " @blur="
                            dateof_filling_affidavits = parseDate(
                              showaddItem.dateof_filling_affidavits
                            )
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="dateof_filling_affidavits"
                      @input="menufiling_affidavits = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <h3>Endorsed Period From</h3>
                  <v-menu v-model="menufiling_endorsed_start" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field clearable @click:clear="
                        $nextTick(() => {
                          showaddItem.endorsed_start = '';
                        })
                        " v-model="showaddItem.endorsed_start" persistent-hint hint="Format DD/MM/YYYY" @keydown.enter="
                          endorsed_start = parseDate(showaddItem.endorsed_start)
                          " @blur="
                            endorsed_start = parseDate(showaddItem.endorsed_start)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="endorsed_start" @input="menufiling_endorsed_start = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <h3>Endorsed Period To</h3>
                  <v-menu v-model="menufiling_endorsed_end" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field clearable @click:clear="
                        $nextTick(() => {
                          showaddItem.endorsed_end = '';
                        })
                        " v-model="showaddItem.endorsed_end" persistent-hint hint="Format DD/MM/YYYY" @keydown.enter="
                          endorsed_end = parseDate(showaddItem.endorsed_end)
                          " @blur="
                            endorsed_end = parseDate(showaddItem.endorsed_end)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="endorsed_end" @input="menufiling_endorsed_end = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </div>
            <div v-if="showIsSearch">
              <v-row class="mt-h">
                <v-col cols="12" sm="4" md="4">
                  <h3>
                    <span class="red--text">* </span>
                    File No.
                    <span class="red--text" v-if="showaddItem.tm_type == 6">(TMS-YY####)</span>
                    <span class="red--text" v-if="showaddItem.tm_type == 10">(TML-YY####)</span>
                  </h3>
                  <v-text-field v-model="showaddItem.file_no" outlined dense @blur="
                    showaddItem.file_no = showaddItem.file_no
                      .trim()
                      .toUpperCase()
                    "></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <h3>Trademark Name</h3>
                  <v-text-field v-model="showaddItem.trademark" outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <h3>Class No.</h3>
                  <v-text-field v-model="showaddItem.class_no" outlined dense></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <!-- Upload Notice -->
                  <v-row class="mt-n3">
                    <v-col cols="12">
                      <h3>Upload Notice File(s)</h3>
                      <input type="file"
                        accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                        multiple="multiple" @change="previewMultiFile" ref="noticefile" style="display: none" />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" @click="$refs.noticefile.click()" class="widthbtnnoticefile" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload</v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-if="filenamenotice.length > 0" class="mt-7">
                    <v-col cols="12" v-for="(item, index) in filenamenotice" :key="index" class="mt-n7">
                      <span @click="previewnoticefilepdf(index)" class="file-link" :class="{
                        'word-file':
                          item.toLowerCase().endsWith('.doc') ||
                          item.toLowerCase().endsWith('.docx'),
                      }">
                        {{ item }}
                      </span>
                      <v-btn icon color="red" @click="confirmdeletenoticefile(index)" style="margin-top: -7px">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <!-- Upload Submitted -->

                  <v-row>
                    <v-col cols="12">
                      <h3>Upload Submitted File(s)</h3>
                      <input type="file"
                        accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                        multiple="multiple" @change="previewMultiAttachFile" ref="attachfile" style="display: none" />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" @click="$refs.attachfile.click()" class="widthbtnnoticefile" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload</v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-if="image_listattach.length > 0" class="mt-7">
                    <v-col cols="12" v-for="(item, index) in image_listattach" :key="index" class="mt-n7">
                      <span @click="previewattachfile(index)" class="file-link" :class="{
                        'pdf-file': item.name.toLowerCase().endsWith('.pdf'),
                        'word-file':
                          item.name.toLowerCase().endsWith('.doc') ||
                          item.name.toLowerCase().endsWith('.docx'),
                      }">
                        {{ item.name }}
                      </span>

                      <v-btn icon color="red" @click="confirmdeleteattachfile(index)" style="margin-top: -7px">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <h3>Upload Receipt(s)</h3>
                      <input type="file" accept="application/pdf,image/png,image/jpeg" multiple="multiple"
                        @change="previewMultiReceipt" ref="receipt" style="display: none" />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" @click="$refs.receipt.click()" class="widthbtnnoticefile" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload</v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="mt-7">
                    <v-col cols="12">
                      <v-row v-if="this.image_listrecicpt.length > 0">
                        <v-col cols="12" v-for="(item, index) in this.image_listrecicpt" :key="index" class="mt-n7">
                          <span @click="previewreceiptfile(index)" class="file-link">
                            {{ item.name }}
                          </span>
                          <v-btn icon color="red" @click="confirmdeleteattreceipt(index)" style="margin-top: -7px">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- <v-row v-if="showaddItem.tm_type == 10">
                    <v-col cols="12" sm="12" md="12">
                      <h3>Upload Goods/Service(.csv)</h3>
                    </v-col>
                  </v-row> -->
                  <!-- <v-row class="mt-h" v-if="showaddItem.tm_type == 10">
                    <v-col cols="12">
                      <input
                        type="file"
                        ref="file_good_service"
                        multiple
                        style="display: none"
                        accept=".csv,text/csv"
                        @change="onFileChange('good_service', $event)"
                      />
                      <v-btn
                        color="#254E58"
                        dark
                        block
                        @click="$refs.file_good_service.click()"
                      >
                        <v-icon left>mdi-cloud-upload</v-icon> Upload
                      </v-btn>
                      <ul v-if="fileList_good_service.length" class="mt-3">
                        <li v-for="(file, i) in fileList_good_service" :key="i">
                          <a
                            :href="fileUrl(file)"
                            :download="file.name"
                            class="word-link"
                            >{{ file.name }}</a
                          >
                          <v-btn
                            icon
                            small
                            color="red"
                            @click="removeFile('good_service', i)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </li>
                      </ul>
                    </v-col>
                  </v-row> -->
                </v-col>
                <v-col cols="12" sm="1" md="1" />
                <v-col cols="12" sm="4" md="4" class="pl-6 pr-6">
                  <v-row v-if="previews.length > 0" class="d-flex justify-center align-center"
                    style="text-align: center">
                    <v-carousel v-model="carouselIndex" hide-delimiter-background height="240" show-arrows
                      show-arrows-on-hover hide-delimiters class="carousel-with-shadow">
                      <v-carousel-item v-for="(src, index) in [...previews].reverse()" :key="index">
                        <div class="image-wrapper-carousel">
                          <!-- preview image -->
                          <div class="counter-overlay">
                            {{ index + 1 }} / {{ previews.length }}
                          </div>
                          <img :src="src" class="preview-img-carousel" @click="
                            popuppreviewimage(previews.length - 1 - index)
                            " />

                          <!-- filename overlay -->
                          <div class="filename-overlay-carousel">
                            {{ imagenames[previews.length - 1 - index] }}
                          </div>

                          <!-- delete button -->
                          <v-btn icon color="red" class="delete-btn-carousel" @click.stop="
                            popupdeleteimage(previews.length - 1 - index)
                            ">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </v-carousel-item>
                    </v-carousel>
                  </v-row>
                  <v-row v-else class="no-image-placeholder" style="
                      text-align: center;
                      padding: 20px;
                      border: 1px dashed #ccc;
                      border-radius: 8px;
                    ">
                    <v-icon color="grey" style="font-size: 48px">mdi-image-off</v-icon>
                    <div style="margin-top: 8px; color: grey">No Image</div>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <h3>Upload Trademark Image (Size 592 x 592)</h3>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="12" md="12">
                      <input type="file" accept="image/*" @change="previewImage" class="inputsize" ref="fileimage"
                        style="display: none" multiple />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" class="widthbtnimagefile" @click="$refs.fileimage.click()" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div v-if="showaddItem.tm_type == 7 || showaddItem.tm_type == 8">
              <v-row align="center">
                <v-col cols="12" sm="12" md="12">
                  <v-row class="mt-h">
                    <v-col cols="12" sm="4" md="4">
                      <h3>Application No.</h3>
                      <v-text-field v-model="showaddItem.app_no" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <h3>IR No.</h3>
                      <v-text-field v-model="showaddItem.ir_no" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <h3>Application Date</h3>
                      <v-menu v-model="menuaddappdate" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field clearable @click:clear="
                            $nextTick(() => {
                              showaddItem.date_of_application = '';
                              date_of_application = '';
                            })
                            " v-model="showaddItem.date_of_application" persistent-hint hint="Format DD/MM/YYYY"
                            @keydown.enter="
                              Selectchangedate_of_application();
                            date_of_application = parseDate(
                              showaddItem.date_of_application
                            );
                            " @blur="
                              Selectchangedate_of_application();
                            date_of_application = parseDate(
                              showaddItem.date_of_application
                            );
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                        </template>
                        <v-date-picker v-model="date_of_application" @change="Selectchangedate_of_application"
                          @input="menuaddappdate = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>

                  <v-row class="mt-h">
                    <v-col cols="12" sm="4" md="4">
                      <h3>
                        <span class="red--text">* </span>
                        File No.
                        <span class="red--text" v-if="showaddItem.tm_type == 7">(TMOP-YY####)</span>
                        <span class="red--text" v-if="
                          showaddItem.tm_type == 11 ||
                          showaddItem.tm_type == 8
                        ">(TMC-YY####)</span>
                      </h3>
                      <v-text-field v-model="showaddItem.file_no" outlined dense @blur="
                        showaddItem.file_no = showaddItem.file_no
                          .trim()
                          .toUpperCase()
                        "></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <h3>Trademark Name</h3>
                      <v-text-field v-model="showaddItem.trademark" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <h3>Class No.</h3>
                      <v-text-field v-model="showaddItem.class_no" outlined dense></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="4" md="4">
                      <h3 v-if="showaddItem.tm_type == 7">Opposed Party</h3>
                      <h3 v-else>Cancellation Party</h3>
                      <v-text-field v-model="showaddItem.opposed_party" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <h3 v-if="showaddItem.tm_type == 7">Opposition Date</h3>
                      <h3 v-if="
                        showaddItem.tm_type == 11 || showaddItem.tm_type == 8
                      ">
                        Cancellation Date
                      </h3>
                      <v-menu v-model="menuopposition" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field clearable @click:clear="
                            $nextTick(() => {
                              showaddItem.date_of_opposition = '';
                              date_of_opposition = '';
                            })
                            " v-model="showaddItem.date_of_opposition" persistent-hint hint="Format DD/MM/YYYY"
                            @keydown.enter="
                              date_of_opposition = parseDate(
                                showaddItem.date_of_opposition
                              )
                              " @blur="
                                date_of_opposition = parseDate(
                                  showaddItem.date_of_opposition
                                )
                                " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                        </template>

                        <v-date-picker v-model="date_of_opposition" @input="menuopposition = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12" sm="4" md="4" class="text-center">
                      <v-row v-if="previews.length > 0" class="d-flex justify-center align-center"
                        style="text-align: center">
                        <v-carousel v-model="carouselIndex" hide-delimiter-background height="240" show-arrows
                          show-arrows-on-hover hide-delimiters class="carousel-with-shadow">
                          <v-carousel-item v-for="(src, index) in [...previews].reverse()" :key="index">
                            <div class="image-wrapper-carousel">
                              <!-- preview image -->
                              <div class="counter-overlay">
                                {{ index + 1 }} / {{ previews.length }}
                              </div>
                              <img :src="src" class="preview-img-carousel" @click="
                                popuppreviewimage(previews.length - 1 - index)
                                " />

                              <!-- filename overlay -->
                              <div class="filename-overlay-carousel">
                                {{ imagenames[previews.length - 1 - index] }}
                              </div>

                              <!-- delete button -->
                              <v-btn icon color="red" class="delete-btn-carousel" @click.stop="
                                popupdeleteimage(previews.length - 1 - index)
                                ">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </div>
                          </v-carousel-item>
                        </v-carousel>
                      </v-row>
                      <v-row v-else class="no-image-placeholder" style="
                          text-align: center;
                          padding: 20px;
                          border: 1px dashed #ccc;
                          border-radius: 8px;
                        ">
                        <v-icon color="grey" style="font-size: 48px">mdi-image-off</v-icon>
                        <div style="margin-top: 8px; color: grey">No Image</div>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <h3>Trademark Image (Size 592 x 592)</h3>
                        </v-col>
                      </v-row>
                      <v-row class="mt-h">
                        <v-col cols="12" sm="12" md="12">
                          <input type="file" accept="image/*" @change="previewImage" class="inputsize" ref="fileimage"
                            style="display: none" multiple />
                          <v-btn :style="{
                            backgroundColor: '#254E58',
                            color: 'white',
                            width: '100%',
                          }" class="widthbtnimagefile" @click="$refs.fileimage.click()" elevation="7">
                            <v-icon left dark color="white">
                              mdi-cloud-upload </v-icon>Upload</v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="text-center">
                      <v-row v-if="previewsOpposed.length > 0" class="d-flex justify-center align-center"
                        style="text-align: center">
                        <v-carousel v-model="carouselIndexOpposed" hide-delimiter-background height="240" show-arrows
                          show-arrows-on-hover hide-delimiters class="carousel-with-shadow">
                          <v-carousel-item v-for="(src, index) in [
                            ...previewsOpposed,
                          ].reverse()" :key="index">
                            <div class="image-wrapper-carousel">
                              <!-- counter -->
                              <div class="counter-overlay">
                                {{ index + 1 }} / {{ previewsOpposed.length }}
                              </div>

                              <!-- image -->
                              <img :src="src" class="preview-img-carousel" @click="
                                popuppreviewimageOpposed(
                                  previewsOpposed.length - 1 - index
                                )
                                " />

                              <!-- filename -->
                              <div class="filename-overlay-carousel">
                                {{
                                  imagenamesOpposed[
                                  previewsOpposed.length - 1 - index
                                  ]
                                }}
                              </div>

                              <!-- delete -->
                              <v-btn icon color="red" class="delete-btn-carousel" @click.stop="
                                popupdeleteimageOpposed(
                                  previewsOpposed.length - 1 - index
                                )
                                ">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </div>
                          </v-carousel-item>
                        </v-carousel>
                      </v-row>

                      <v-row v-else class="no-image-placeholder" style="
                          text-align: center;
                          padding: 20px;
                          border: 1px dashed #ccc;
                          border-radius: 8px;
                        ">
                        <v-icon color="grey" style="font-size: 48px">mdi-image-off</v-icon>
                        <div style="margin-top: 8px; color: grey">No Image</div>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <h3 v-if="showaddItem.tm_type == 7">
                            Opposed Trademark Image (Size 592 x 592)
                          </h3>
                          <h3 v-else>
                            Cancellation Trademark Image (Size 592 x 592)
                          </h3>
                        </v-col>
                      </v-row>

                      <v-row class="mt-h">
                        <v-col cols="12">
                          <input type="file" accept="image/*" @change="previewImageOpposed" class="inputsize"
                            ref="fileimageOpposed" style="display: none" multiple />
                          <v-btn :style="{
                            backgroundColor: '#254E58',
                            color: 'white',
                            width: '100%',
                          }" class="widthbtnimagefile" @click="$refs.fileimageOpposed.click()" elevation="7">
                            <v-icon left dark color="white">mdi-cloud-upload</v-icon>
                            Upload
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" sm="4" md="4" class="text-center"></v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div v-if="showaddItem.tm_type == 11">
              <v-row align="center">
                <v-col cols="12" sm="8" md="8">
                  <v-row class="mt-h">
                    <v-col cols="12" sm="6" md="6">
                      <h3>Application No.</h3>
                      <v-text-field v-model="showaddItem.app_no" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <h3>Class No.</h3>
                      <v-text-field v-model="showaddItem.class_no" outlined dense></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="6" md="6">
                      <h3>IR No.</h3>
                      <v-text-field v-model="showaddItem.ir_no" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <h3>Application Date</h3>
                      <v-menu v-model="menuaddappdate" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field clearable @click:clear="
                            $nextTick(() => {
                              showaddItem.date_of_application = '';
                              date_of_application = '';
                            })
                            " v-model="showaddItem.date_of_application" persistent-hint hint="Format DD/MM/YYYY"
                            @keydown.enter="
                              Selectchangedate_of_application();
                            date_of_application = parseDate(
                              showaddItem.date_of_application
                            );
                            " @blur="
                              Selectchangedate_of_application();
                            date_of_application = parseDate(
                              showaddItem.date_of_application
                            );
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                        </template>
                        <v-date-picker v-model="date_of_application" @change="Selectchangedate_of_application"
                          @input="menuaddappdate = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="6" md="6">
                      <h3>
                        <span class="red--text">* </span>
                        File No.
                        <span class="red--text" v-if="showaddItem.tm_type == 7">(TMOP-YY####)</span>
                        <span class="red--text" v-if="
                          showaddItem.tm_type == 11 ||
                          showaddItem.tm_type == 8
                        ">(TMC-YY####)</span>
                      </h3>
                      <v-text-field v-model="showaddItem.file_no" outlined dense @blur="
                        showaddItem.file_no = showaddItem.file_no
                          .trim()
                          .toUpperCase()
                        "></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <h3>Trademark Name</h3>
                      <v-text-field v-model="showaddItem.trademark" outlined dense></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="6" md="6">
                      <h3 v-if="
                        showaddItem.tm_type == 7 || showaddItem.tm_type == 8
                      ">
                        Opposition Date
                      </h3>
                      <h3 v-if="showaddItem.tm_type == 11">
                        Cancellation Date
                      </h3>
                      <v-menu v-model="menuopposition" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field clearable @click:clear="
                            $nextTick(() => {
                              showaddItem.date_of_opposition = '';
                              date_of_opposition = '';
                            })
                            " v-model="showaddItem.date_of_opposition" persistent-hint hint="Format DD/MM/YYYY"
                            @keydown.enter="
                              date_of_opposition = parseDate(
                                showaddItem.date_of_opposition
                              )
                              " @blur="
                                date_of_opposition = parseDate(
                                  showaddItem.date_of_opposition
                                )
                                " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                        </template>

                        <v-date-picker v-model="date_of_opposition" @input="menuopposition = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-row class="pl-6 pr-6">
                    <v-col cols="12" sm="12" md="12">
                      <v-row v-if="previews.length > 0" class="d-flex justify-center align-center"
                        style="text-align: center">
                        <v-carousel v-model="carouselIndex" hide-delimiter-background height="240" show-arrows
                          show-arrows-on-hover hide-delimiters class="carousel-with-shadow">
                          <v-carousel-item v-for="(src, index) in [...previews].reverse()" :key="index">
                            <div class="image-wrapper-carousel">
                              <!-- preview image -->
                              <div class="counter-overlay">
                                {{ index + 1 }} / {{ previews.length }}
                              </div>
                              <img :src="src" class="preview-img-carousel" @click="
                                popuppreviewimage(previews.length - 1 - index)
                                " />

                              <!-- filename overlay -->
                              <div class="filename-overlay-carousel">
                                {{ imagenames[previews.length - 1 - index] }}
                              </div>

                              <!-- delete button -->
                              <v-btn icon color="red" class="delete-btn-carousel" @click.stop="
                                popupdeleteimage(previews.length - 1 - index)
                                ">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </div>
                          </v-carousel-item>
                        </v-carousel>
                      </v-row>
                      <v-row v-else class="no-image-placeholder" style="
                          text-align: center;
                          padding: 20px;
                          border: 1px dashed #ccc;
                          border-radius: 8px;
                        ">
                        <v-icon color="grey" style="font-size: 48px">mdi-image-off</v-icon>
                        <div style="margin-top: 8px; color: grey">No Image</div>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <h3>Trademark Image (592 x 592)</h3>
                      <input type="file" accept="image/*" @change="previewImage" class="inputsize" ref="fileimage"
                        style="display: none" multiple />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" class="widthbtnimagefile" @click="$refs.fileimage.click()" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Upload Notice -->
              <v-row class="mt-h">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="5">
                      <h3>Upload Notice File(s)</h3>
                      <input type="file" ref="file_notice" multiple style="display: none"
                        accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                        @change="onFileChange('notice', $event)" />
                      <v-btn color="#254E58" dark block @click="$refs.file_notice.click()">
                        <v-icon left>mdi-cloud-upload</v-icon> Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12">
                      <ul v-if="fileList_notice.length">
                        <li v-for="(file, i) in fileList_notice" :key="i">
                          <template v-if="file.name.toLowerCase().endsWith('.pdf')">
                            <a :href="fileUrl(file)" target="_blank" class="pdf-link">{{ file.name }}</a>
                          </template>
                          <template v-else>
                            <a :href="fileUrl(file)" :download="file.name" class="word-link">{{ file.name }}</a>
                          </template>
                          <v-btn icon small color="red" @click="removeFile('notice', i)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Upload Submitted -->
              <v-row class="mt-h">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="5">
                      <h3>Upload Submitted File(s)</h3>
                      <input type="file" ref="file_submitted" multiple style="display: none"
                        accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                        @change="onFileChange('submitted', $event)" />
                      <v-btn color="#254E58" dark block @click="$refs.file_submitted.click()">
                        <v-icon left>mdi-cloud-upload</v-icon> Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12">
                      <ul v-if="fileList_submitted.length">
                        <li v-for="(file, i) in fileList_submitted" :key="i">
                          <template v-if="file.name.toLowerCase().endsWith('.pdf')">
                            <a :href="fileUrl(file)" target="_blank" class="pdf-link">{{ file.name }}</a>
                          </template>
                          <template v-else>
                            <a :href="fileUrl(file)" :download="file.name" class="word-link">{{ file.name }}</a>
                          </template>
                          <v-btn icon small color="red" @click="removeFile('submitted', i)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Upload Receipt -->
              <v-row class="mt-h">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="5">
                      <h3>Upload Receipt(s)</h3>
                      <input type="file" ref="file_receipt" multiple style="display: none"
                        accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                        @change="onFileChange('receipt', $event)" />
                      <v-btn color="#254E58" dark block @click="$refs.file_receipt.click()">
                        <v-icon left>mdi-cloud-upload</v-icon> Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12">
                      <ul v-if="fileList_receipt.length">
                        <li v-for="(file, i) in fileList_receipt" :key="i">
                          <template v-if="file.name.toLowerCase().endsWith('.pdf')">
                            <a :href="fileUrl(file)" target="_blank" class="pdf-link">{{ file.name }}</a>
                          </template>
                          <template v-else>
                            <a :href="fileUrl(file)" :download="file.name" class="word-link">{{ file.name }}</a>
                          </template>
                          <v-btn icon small color="red" @click="removeFile('receipt', i)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Upload Good Service -->
              <v-row class="mt-h">
                <v-col cols="12">
                  <v-row>
                    <v-col cols="5">
                      <h3>Upload Goods/Service(.csv)</h3>
                      <input type="file" ref="file_good_service" multiple style="display: none" accept=".csv,text/csv"
                        @change="onFileChange('good_service', $event)" />
                      <v-btn color="#254E58" dark block @click="$refs.file_good_service.click()">
                        <v-icon left>mdi-cloud-upload</v-icon> Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12">
                      <ul v-if="fileList_good_service.length">
                        <li v-for="(file, i) in fileList_good_service" :key="i">
                          <a :href="fileUrl(file)" :download="file.name" class="word-link">{{ file.name }}</a>
                          <v-btn icon small color="red" @click="removeFile('good_service', i)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div v-if="showTrademarkInfringementPoliceCustoms">
              <v-row align="center">
                <v-col cols="12" sm="8" md="8">
                  <v-row class="mt-h">
                    <v-col cols="12" sm="6" md="6">
                      <h3>Application No.</h3>
                      <v-text-field v-model="showaddItem.app_no" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <h3>Class No.</h3>
                      <v-text-field v-model="showaddItem.class_no" outlined dense></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="6" md="6">
                      <h3>IR No.</h3>
                      <v-text-field v-model="showaddItem.ir_no" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <h3>Application Date</h3>
                      <v-menu v-model="menuaddappdate" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field clearable @click:clear="
                            $nextTick(() => {
                              showaddItem.date_of_application = '';
                              date_of_application = '';
                            })
                            " v-model="showaddItem.date_of_application" persistent-hint hint="Format DD/MM/YYYY"
                            @keydown.enter="
                              Selectchangedate_of_application();
                            date_of_application = parseDate(
                              showaddItem.date_of_application
                            );
                            " @blur="
                              Selectchangedate_of_application();
                            date_of_application = parseDate(
                              showaddItem.date_of_application
                            );
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                        </template>
                        <v-date-picker v-model="date_of_application" @change="Selectchangedate_of_application"
                          @input="menuaddappdate = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="6" md="6">
                      <h3>
                        <span class="red--text">* </span>
                        File No.
                        <span class="red--text">(TMI-YY####)</span>
                      </h3>
                      <v-text-field v-model="showaddItem.file_no" outlined dense @blur="
                        showaddItem.file_no = showaddItem.file_no
                          .trim()
                          .toUpperCase()
                        "></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <h3>Trademark Name</h3>
                      <v-text-field v-model="showaddItem.trademark" outlined dense></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-h">
                    <v-col cols="12" sm="6" md="6">
                      <h3>Infringement Date</h3>
                      <v-menu v-model="menuopposition" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field clearable @click:clear="
                            $nextTick(() => {
                              showaddItem.date_of_infringement = '';
                              date_of_infringement = '';
                            })
                            " v-model="showaddItem.date_of_infringement" persistent-hint hint="Format DD/MM/YYYY"
                            @keydown.enter="
                              date_of_infringement = parseDate(
                                showaddItem.date_of_infringement
                              )
                              " @blur="
                                date_of_infringement = parseDate(
                                  showaddItem.date_of_infringement
                                )
                                " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                        </template>

                        <v-date-picker v-model="date_of_infringement" @input="menuopposition = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <h3>หน่วยงาน</h3>
                      <v-autocomplete clearable @click:clear="
                        $nextTick(() => {
                          showaddItem.agency = '';
                        })
                        " v-model="showaddItem.agency" :items="Agency_list" outlined dense></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-row class="pl-6 pr-6">
                    <v-col cols="12" sm="12" md="12">
                      <v-row v-if="previews.length > 0" class="d-flex justify-center" style="text-align: center">
                        <v-carousel v-model="carouselIndex" hide-delimiter-background height="240" show-arrows
                          show-arrows-on-hover hide-delimiters class="carousel-with-shadow">
                          <v-carousel-item v-for="(src, index) in [...previews].reverse()" :key="index">
                            <div class="image-wrapper-carousel">
                              <!-- preview image -->
                              <div class="counter-overlay">
                                {{ index + 1 }} / {{ previews.length }}
                              </div>
                              <img :src="src" class="preview-img-carousel" @click="
                                popuppreviewimage(previews.length - 1 - index)
                                " />

                              <!-- filename overlay -->
                              <div class="filename-overlay-carousel">
                                {{ imagenames[previews.length - 1 - index] }}
                              </div>

                              <!-- delete button -->
                              <v-btn icon color="red" class="delete-btn-carousel" @click.stop="
                                popupdeleteimage(previews.length - 1 - index)
                                ">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </div>
                          </v-carousel-item>
                        </v-carousel>
                      </v-row>
                      <v-row v-else class="no-image-placeholder" style="
                          text-align: center;
                          padding: 20px;
                          border: 1px dashed #ccc;
                          border-radius: 8px;
                        ">
                        <v-icon color="grey" style="font-size: 48px">mdi-image-off</v-icon>
                        <div style="margin-top: 8px; color: grey">No Image</div>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <h3>Trademark Image (592 x 592)</h3>
                      <input type="file" accept="image/*" @change="previewImage" class="inputsize" ref="fileimage"
                        style="display: none" multiple />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" class="widthbtnimagefile" @click="$refs.fileimage.click()" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Upload Notice -->
              <v-row>
                <v-col cols="5">
                  <!-- Upload Notice -->
                  <v-row class="mt-n3">
                    <v-col cols="12">
                      <h3>Upload Notice File(s)</h3>
                      <input type="file"
                        accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                        multiple="multiple" @change="previewMultiFile" ref="noticefile" style="display: none" />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" @click="$refs.noticefile.click()" class="widthbtnnoticefile" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="7" class="mt-13">
                  <v-row v-if="filenamenotice.length > 0">
                    <v-col cols="12" v-for="(item, index) in filenamenotice" :key="index" class="mt-n7">
                      <span @click="previewnoticefilepdf(index)" class="file-link" :class="{
                        'word-file':
                          item.toLowerCase().endsWith('.doc') ||
                          item.toLowerCase().endsWith('.docx'),
                      }">
                        {{ item }}
                      </span>
                      <v-btn icon color="red" @click="confirmdeletenoticefile(index)" style="margin-top: -7px">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Upload Submitted -->
              <v-row class="mt-h">
                <v-col cols="5">
                  <v-row>
                    <v-col cols="12">
                      <h3>Upload Submitted File(s)</h3>
                      <input type="file"
                        accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                        multiple="multiple" @change="previewMultiAttachFile" ref="attachfile" style="display: none" />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" @click="$refs.attachfile.click()" class="widthbtnnoticefile" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="7" class="mt-4">
                  <v-row v-if="image_listattach.length > 0" class="mt-7">
                    <v-col cols="12" v-for="(item, index) in image_listattach" :key="index" class="mt-n7">
                      <span @click="previewattachfile(index)" class="file-link" :class="{
                        'pdf-file': item.name.toLowerCase().endsWith('.pdf'),
                        'word-file':
                          item.name.toLowerCase().endsWith('.doc') ||
                          item.name.toLowerCase().endsWith('.docx'),
                      }">
                        {{ item.name }}
                      </span>

                      <v-btn icon color="red" @click="confirmdeleteattachfile(index)" style="margin-top: -7px">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Upload Receipt -->
              <v-row class="mt-h">
                <v-col cols="5">
                  <h3>Upload Receipt(s)</h3>
                  <input type="file" accept="application/pdf,image/png,image/jpeg" multiple="multiple"
                    @change="previewMultiReceipt" ref="receipt" style="display: none" />
                  <v-btn :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                  }" @click="$refs.receipt.click()" class="widthbtnnoticefile" elevation="7">
                    <v-icon left dark color="white"> mdi-cloud-upload </v-icon>Upload</v-btn>
                </v-col>
                <v-col cols="7" class="mt-13 pr-4">
                  <v-row v-if="this.image_listrecicpt.length > 0">
                    <v-col cols="12" v-for="(item, index) in this.image_listrecicpt" :key="index" class="mt-n7">
                      <span @click="previewreceiptfile(index)" class="file-link">
                        {{ item.name }}
                      </span>
                      <v-btn icon color="red" @click="confirmdeleteattreceipt(index)" style="margin-top: -7px">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Upload Good Service -->
              <v-row class="mt-h">
                <v-col cols="5">
                  <h3>Upload Goods/Service(.csv)</h3>
                  <input type="file" ref="file_good_service" style="display: none" accept=".csv,text/csv"
                    @change="uploadCSVFile($event)" />
                  <v-btn color="#254E58" dark block @click="$refs.file_good_service.click()">
                    <v-icon left>mdi-cloud-upload</v-icon> Upload
                  </v-btn>
                </v-col>
                <v-col cols="7" class="mt-7">
                  <ul v-if="fileList_good_service.length">
                    <li v-for="(file, i) in fileList_good_service" :key="i">
                      <a :href="fileUrl(file)" :download="file.name" class="word-link">{{ file.name }}</a>
                      <v-btn icon small color="red" @click="removeFileGood('good_service', i)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" sm="5" md="5">
            <v-row class="d-flex" style="margin-top: 25px">
              <v-col cols="12" sm="4" md="4" class="d-flex justify-end" style="margin-top: 10px">
                <h3>Client Name</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-autocomplete v-model="owner_contact_list" :items="contact_owner_list" item-text="contact_name"
                  item-value="contact_id" clearable multiple outlined dense return-object @click:clear="
                    $nextTick(() => {
                      owner_contact_list = [];
                      owner_address = '';
                    })
                    " @change="onSelectOwnerChange()">
                  <!-- Slot to display checkbox -->
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="item" small>
                      {{ item.contact_name }}
                    </v-chip>
                  </template>

                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-bind="attrs" v-on="on">
                      <v-list-item-action>
                        <v-checkbox :input-value="owner_contact_list.includes(item)" />
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title v-text="item.contact_name" />
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -25px">
              <v-col cols="12" sm="4" md="4" class="d-flex justify-end">
                <h3>Client Address</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-card class="text-field-style scrollable-card" outlined dense>
                  <div v-if="owner_contact_list.length > 0" v-for="(item, index) in owner_contact_list" :key="index"
                    :style="{
                      paddingTop: '7px',
                      lineHeight: '1.2',
                      paddingBottom:
                        index == owner_contact_list.length - 1 ? '7px' : '0',
                    }">
                    <span><b>{{ item.contact_name }}: </b>
                      {{ item.owner_address }}</span><br />
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row style="margin-top: -18px">
              <v-col cols="12" sm="4" md="4" class="d-flex align-start justify-end" style="margin-top: 10px">
                <h3>Agent Reference</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field v-model="showaddItem.cliant_ref" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row style="margin-top: -18px">
              <v-col cols="12" sm="4" md="4" class="d-flex align-start justify-end" style="margin-top: 10px">
                <h3>Agent</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    showaddItem.agent_contact = 0;
                    showaddItem.agent_address = '';
                  })
                  " v-model="showaddItem.agent_contact" :items="contact_agent_list" item-text="contact_name"
                  item-value="contact_id" outlined @change="onSelectAgentChange(showaddItem.agent_contact)"
                  dense></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -40px">
              <v-col cols="12" sm="4" md="4" class="d-flex align-start justify-end" style="margin-top: 10px">
                <h3>Agent Email</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field v-model="showaddItem.agent_email" outlined dense background-color="#F5F5F5"
                  disabled></v-text-field>
              </v-col>
            </v-row>
            <v-row style="margin-top: -40px">
              <v-col cols="12" sm="4" md="4" class="d-flex align-start justify-end" style="margin-top: 10px">
                <h3>Agent Address</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-textarea v-model="showaddItem.agent_address" multi-line outlined dense background-color="#F5F5F5"
                  disabled></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: -18px">
              <v-col cols="12" sm="4" md="4" align="right">
                <h3>Associate</h3>
                <h3>(Oversea)</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    showaddItem.associate_contact = 0;
                    showaddItem.associate_address = '';
                  })
                  " v-model="showaddItem.associate_contact" :items="contact_associate_list" item-text="contact_name"
                  item-value="contact_id" outlined @change="
                    onSelectAssociateChange(showaddItem.associate_contact)
                    " dense></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -40px">
              <v-col cols="12" sm="4" md="4" align="right" style="margin-top: 10px">
                <h3>Associate Address</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-textarea v-model="showaddItem.associate_address" multi-line outlined dense background-color="#F5F5F5"
                  disabled></v-textarea>
              </v-col>
            </v-row>

            <v-row style="margin-top: -18px">
              <v-col cols="12" sm="4" md="4" align="right">
                <h3>Billing To</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    customer_selected = null;
                    customer_address = '';
                  })
                  " v-model="customer_selected" :items="customer_list" item-text="name" item-value="id" outlined
                  @change="onSelectComboboxMetterChange(customer_selected)" dense></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -40px">
              <v-col cols="12" sm="4" md="4" align="right" style="margin-top: 10px">
                <h3>Billing Address</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-textarea v-model="customer_address" multi-line outlined dense background-color="#F5F5F5"
                  disabled></v-textarea>
              </v-col>
            </v-row>
            <v-row style="margin-top: -18px">
              <v-col cols="12" sm="4" md="4" align="right" class="mt-2">
                <h3>Send Billing To</h3>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-autocomplete clearable @click:clear="
                  $nextTick(() => {
                    sendBilling = null;
                    sendBillingDetail = '';
                  })
                  " v-model="sendBilling" :items="sendBillingList" outlined dense></v-autocomplete>
              </v-col>
            </v-row>
            <v-row style="margin-top: -40px">
              <v-col cols="12" sm="4" md="4" align="right" class="mt-2" />
              <v-col cols="12" sm="8" md="8">
                <v-text-field v-if="
                  sendBilling == 'Link' || sendBilling == 'Specific Email'
                " v-model="sendBillingDetail" outlined dense></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div v-if="showFiling">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <h3>Goods / Service</h3>
              <v-textarea v-model="showaddItem.good_service" multi-line outlined dense background-color="#F5F5F5"
                disabled></v-textarea>
            </v-col>
          </v-row>
          <v-row class="mt-h">
            <v-col cols="12" sm="12" md="12">
              <v-row> </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3">
                  <h3>Trademark Status</h3>
                  <v-autocomplete clearable @click:clear="
                    $nextTick(() => {
                      showaddItem.tmstatusasoff = 0;
                    })
                    " v-model="showaddItem.tmstatusasoff" :items="tmstatus_list" item-text="tmupdatestatus_name"
                    item-value="tmupdatestatus_id" outlined @change="onSelectCustomerChange(showaddItem.tmstatusasoff)"
                    dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="9" md="9">
                  <h3>Remark</h3>
                  <v-textarea v-model="showaddItem.remark" multi-line outlined dense></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="9" md="9">
              <v-row class="mt-h mb-10">
                <v-col cols="12" sm="12" md="12">
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <h3>
                        Upload File
                        <span class="red--text">(Support .pdf files only)
                        </span>
                      </h3>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="12" style="margin-top: -20px">
                  <v-row>
                    <v-col cols="4" sm="4" md="4">
                      <input type="file" accept="application/pdf,application/vnd.ms-excel" multiple="multiple"
                        @change="previewMultiImage" class="inputsize" ref="filefile" style="display: none" />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" class="widthbtnimagefile" @click="$refs.filefile.click()" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload file</v-btn>
                    </v-col>
                    <v-col cols="1" sm="1" md="1" />
                    <v-col cols="7" sm="7" md="7" class="mt-4">
                      <!-- {{ filename }} -->
                      <v-row v-for="(item, index) in image_list" :key="index">
                        <span @click="popuppreviewfile(index)" class="file-link">
                          {{ item.name }}
                        </span>
                        <v-btn icon color="red" @click="popupdeletefile(index)" style="margin-top: -7px">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="mt-h mb-10">
                <v-col cols="12" sm="12" md="12">
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <h3>
                        Upload Certificate
                        <span class="red--text">(Support .pdf files only)
                        </span>
                      </h3>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="12" style="margin-top: -20px">
                  <v-row>
                    <v-col cols="4" sm="4" md="4">
                      <input type="file" accept="application/pdf,application/vnd.ms-excel" multiple="multiple"
                        @change="previewMultiImage_cer" class="inputsize" ref="cer" style="display: none" />
                      <v-btn :style="{
                        backgroundColor: '#254E58',
                        color: 'white',
                        width: '100%',
                      }" class="widthbtnimagefile" @click="$refs.cer.click()" elevation="7">
                        <v-icon left dark color="white">
                          mdi-cloud-upload </v-icon>Upload file</v-btn>
                    </v-col>
                    <v-col cols="1" sm="1" md="1" />
                    <v-col cols="7" sm="7" md="7" class="mt-4">
                      <v-row v-for="(item_cer, index_cer) in image_list_cer" :key="index_cer" class="align-center">
                        <span @click="popuppreviewfile_cer(index_cer)" class="file-link">
                          {{ item_cer.name }}
                        </span>
                        <v-btn icon color="red" @click="popupdeletefile_cer(index_cer)" style="margin-top: -7px">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <h3>Link With Search Type (TMS-YY####)</h3>
              <!-- <v-text-field v-model="priority.country" outlined dense /> -->
              <v-autocomplete clearable @click:clear="
                $nextTick(() => {
                  showaddItem.ref_search = 0;
                })
                " v-model="showaddItem.ref_search" :items="ref_search_list" item-text="file_no"
                item-value="mastertm_id" outlined dense></v-autocomplete>
            </v-col>
          </v-row>
        </div>
        <div v-if="showIsSearch">
          <v-row v-if="showaddItem.tm_type == 10">
            <v-col cols="12" sm="12" md="12">
              <v-row v-for="(box, index) in decisionBoxes" :key="index" class="mb-6">
                <v-col cols="12" md="8">
                  <div class="decision-box">
                    <!-- Header -->
                    <div class="box-header d-flex justify-space-between align-center">
                      <h3>Upload Decision Document ({{ labels[index] }})</h3>
                      <div>
                        <v-btn icon color="#2196F3" v-if="
                          index === decisionBoxes.length - 1 && index != 2
                        " @click="addBox(index)">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn icon color="error" v-if="index === decisionBoxes.length - 1" @click="removeBox(index)">
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                      </div>
                    </div>

                    <!-- Upload -->
                    <v-row class="mt-n7">
                      <v-col cols="12" md="5" class="pr-8">
                        <v-btn width="100%" color="#254E58" dark @click="triggerUpload(index)">
                          <v-icon left>mdi-cloud-upload</v-icon>Upload
                        </v-btn>

                        <!-- Hidden file input -->
                        <input type="file" multiple ref="fileInputs" class="hidden-input" accept="application/pdf"
                          @change="onFilesSelected(index, $event)" />
                      </v-col>

                      <!-- Show files -->
                      <v-col cols="12" md="7" class="mt-4 vertical-line" v-if="box.files.length > 0">
                        <v-row v-for="(file, fIndex) in box.files" :key="fIndex" class="pl-8">
                          <span @click="previewBoxfile(index, fIndex)" class="file-link">{{ file.name }}
                          </span>
                          <v-btn icon @click="removeFileBox(index, fIndex)" class="mt-n1">
                            <v-icon color="red" style="font-size: 16px">mdi-close</v-icon>
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>

                    <!-- Date -->
                    <v-row>
                      <v-col cols="12" md="12" class="mt-4">
                        <h3>
                          Receive Date For Decision Document ({{
                            labelsDecripnt[index]
                          }})
                        </h3>
                      </v-col>
                    </v-row>
                    <v-row class="mt-n4">
                      <v-col cols="12" md="4">
                        <v-menu v-model="box.menuReceiveBox" :close-on-content-click="false" offset-y min-width="auto">
                          <template #activator="{ on, attrs }">
                            <v-text-field :value="formatDateToDMY(box.date)" append-icon="mdi-calendar" outlined dense
                              readonly @click="box.menuReceiveBox = true" />
                          </template>
                          <v-date-picker v-model="box.date" @input="box.menuReceiveBox = false" />
                        </v-menu>
                      </v-col>

                      <!-- Radio -->
                      <v-col cols="12" md="8" class="mt-n4">
                        <v-radio-group v-model="box.result">
                          <v-radio v-if="index === 0 || index === 1" label="Successful (สำเร็จ)"
                            value="Successful (สำเร็จ)" />
                          <v-radio v-if="index === 0 || index === 1" label="Unsuccessful (ไม่สำเร็จ)"
                            value="Unsuccessful (ไม่สำเร็จ)" />
                          <v-radio v-if="index === 2" label="Referred to Litigation (ส่งต่อให้ฝ่ายคดีความ)"
                            value="Referred to Litigation (ส่งต่อให้ฝ่ายคดีความ)" />
                          <v-radio v-if="index === 2" label="Not Referred to Litigation (ไม่ส่งต่อให้ฝ่ายคดีความ)"
                            value="Not Referred to Litigation (ไม่ส่งต่อให้ฝ่ายคดีความ)" />
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row v-if="showaddItem.tm_type == 10">
            <v-col cols="12" sm="12" md="12">
              <h3>Goods / Service</h3>
              <v-textarea v-model="showaddItem.good_service" multi-line outlined dense background-color="#F5F5F5"
                disabled></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-row v-if="showaddItem.tm_type == 6">
                <v-col cols="12" sm="3" md="3">
                  <h3><span class="red--text">* </span>Receive Date</h3>
                  <v-menu v-model="menuReceive" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.receive_date" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          receive_date = parseDate(showaddItem.receive_date)
                          " @blur="
                            receive_date = parseDate(showaddItem.receive_date)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="receive_date" @input="
                      () => {
                        menuReceive = false;
                        calDateFinalDeadline();
                      }
                    "></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h3>Submit Date</h3>
                  <v-menu v-model="menuFilling" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.filling_date" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          filling_date = parseDate(showaddItem.filling_date)
                          " @blur="
                            filling_date = parseDate(showaddItem.filling_date)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="filling_date" @input="menuFilling = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h3><span class="red--text">* </span>Final Deadline</h3>
                  <v-menu v-model="menuStart" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.enddate" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          enddate = parseDate(showaddItem.enddate)
                          " @blur="enddate = parseDate(showaddItem.enddate)" append-icon="mdi-calendar" v-bind="attrs"
                        v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="enddate" @input="onSelectFinalDeadlineSearch"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h3><span class="red--text">* </span>Fixed Internal Date</h3>
                  <v-menu v-model="menuDeadline" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.internaldate" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          internaldate = parseDate(showaddItem.internaldate)
                          " @blur="
                            internaldate = parseDate(showaddItem.internaldate)
                            " v-bind="attrs" v-on="on" outlined dense disabled
                        background-color="#F5F5F5"></v-text-field>
                    </template>

                    <v-date-picker v-model="internaldate" @input="menuDeadline = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row v-if="showaddItem.tm_type == 10">
                <v-col cols="12" sm="3" md="3">
                  <h3><span class="red--text">* </span>Receive Date</h3>
                  <v-menu v-model="menuReceive" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.receive_date" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          receive_date = parseDate(showaddItem.receive_date)
                          " @blur="
                            receive_date = parseDate(showaddItem.receive_date)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="receive_date" @input="
                      () => {
                        menuReceive = false;
                      }
                    "></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h3>Submit Date</h3>
                  <v-menu v-model="menuFilling" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.filling_date" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          filling_date = parseDate(showaddItem.filling_date)
                          " @blur="
                            filling_date = parseDate(showaddItem.filling_date)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="filling_date" @input="menuFilling = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6"> </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="3">
                  <h3>Trademark Status</h3>
                  <v-autocomplete clearable @click:clear="
                    $nextTick(() => {
                      showaddItem.tmstatusasoff = 0;
                    })
                    " v-model="showaddItem.tmstatusasoff" :items="tmstatus_list" item-text="tmupdatestatus_name"
                    item-value="tmupdatestatus_id" outlined @change="onSelectCustomerChange(showaddItem.tmstatusasoff)"
                    dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="9" md="9">
                  <h3>Remark</h3>
                  <v-textarea v-model="showaddItem.remark" multi-line outlined dense></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <div v-if="showaddItem.tm_type == 7 || showaddItem.tm_type == 8">
          <v-row v-if="showaddItem.tm_type != 7" v-for="(box, index) in decisionBoxes" :key="index" class="mb-6">
            <v-col cols="12" md="8">
              <div class="decision-box">
                <!-- Header -->
                <div class="box-header d-flex justify-space-between align-center">
                  <h3>Upload Decision Document ({{ labels[index] }})</h3>
                  <div v-if="showaddItem.tm_type == 7">
                    <v-btn icon color="#2196F3" v-if="index === decisionBoxes.length - 1 && index != 2"
                      @click="addBox(index)">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn icon color="error" v-if="index === decisionBoxes.length - 1" @click="removeBox(index)">
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                  </div>
                  <div v-if="showaddItem.tm_type == 8">
                    <v-btn icon color="#2196F3" v-if="index === 0 && decisionBoxes.length <= 1" @click="addBox(index)">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn icon color="error" v-if="index === 1" @click="removeBox(index)">
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                  </div>
                </div>

                <!-- Upload -->
                <v-row class="mt-n7">
                  <v-col cols="12" md="5" class="pr-8">
                    <v-btn width="100%" color="#254E58" dark @click="triggerUpload(index)">
                      <v-icon left>mdi-cloud-upload</v-icon>Upload
                    </v-btn>

                    <!-- Hidden file input -->
                    <input type="file" multiple ref="fileInputs" class="hidden-input" accept="application/pdf"
                      @change="onFilesSelected(index, $event)" />
                  </v-col>

                  <!-- Show files -->
                  <v-col cols="12" md="7" class="mt-4 vertical-line" v-if="box.files.length > 0">
                    <v-row v-for="(file, fIndex) in box.files" :key="fIndex" class="pl-8">
                      <span @click="previewBoxfile(index, fIndex)" class="file-link">{{ file.name }}
                      </span>
                      <v-btn icon @click="removeFileBox(index, fIndex)" class="mt-n1">
                        <v-icon color="red" style="font-size: 16px">mdi-close</v-icon>
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>

                <!-- Date -->
                <v-row>
                  <v-col cols="12" md="12" class="mt-4">
                    <h3>
                      Receive Date For Decision Document ({{
                        labelsDecripnt[index]
                      }})
                    </h3>
                  </v-col>
                </v-row>
                <v-row class="mt-n4">
                  <v-col cols="12" md="4">
                    <v-menu v-model="box.menuReceiveBox" :close-on-content-click="false" offset-y min-width="auto">
                      <template #activator="{ on, attrs }">
                        <v-text-field :value="formatDateToDMY(box.date)" append-icon="mdi-calendar" outlined dense
                          readonly @click="box.menuReceiveBox = true" />
                      </template>
                      <v-date-picker v-model="box.date" @input="box.menuReceiveBox = false" />
                    </v-menu>
                  </v-col>

                  <!-- Radio -->
                  <v-col cols="12" md="8" class="mt-n4">
                    <v-radio-group v-model="box.result" v-if="showaddItem.tm_type == 7">
                      <v-radio v-if="index === 0 || index === 1" label="Successful (สำเร็จ)"
                        value="Successful (สำเร็จ)" />
                      <v-radio v-if="index === 0 || index === 1" label="Unsuccessful (ไม่สำเร็จ)"
                        value="Unsuccessful (ไม่สำเร็จ)" />
                      <v-radio v-if="index === 2" label="Referred to Litigation (ส่งต่อให้ฝ่ายคดีความ)"
                        value="Referred to Litigation (ส่งต่อให้ฝ่ายคดีความ)" />
                      <v-radio v-if="index === 2" label="Not Referred to Litigation (ไม่ส่งต่อให้ฝ่ายคดีความ)"
                        value="Not Referred to Litigation (ไม่ส่งต่อให้ฝ่ายคดีความ)" />
                    </v-radio-group>
                    <v-radio-group v-model="box.result" v-if="showaddItem.tm_type == 8">
                      <v-radio v-if="index === 0" label="Successful (สำเร็จ)" value="Successful (สำเร็จ)" />
                      <v-radio v-if="index === 0" label="Unsuccessful (ไม่สำเร็จ)" value="Unsuccessful (ไม่สำเร็จ)" />
                      <v-radio v-if="index === 1" label="Referred to Litigation (ส่งต่อให้ฝ่ายคดีความ)"
                        value="Referred to Litigation (ส่งต่อให้ฝ่ายคดีความ)" />
                      <v-radio v-if="index === 1" label="Not Referred to Litigation (ไม่ส่งต่อให้ฝ่ายคดีความ)"
                        value="Not Referred to Litigation (ไม่ส่งต่อให้ฝ่ายคดีความ)" />
                    </v-radio-group>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-row class="mt-h">
                <v-col cols="12" sm="12" md="12">
                  <h3>Goods / Service</h3>
                  <v-textarea v-model="showaddItem.good_service" multi-line outlined dense background-color="#F5F5F5"
                    disabled></v-textarea>
                </v-col>
              </v-row>

              <v-row class="mt-h">
                <v-col cols="12" sm="3" md="3">
                  <h3>Trademark Status</h3>
                  <v-autocomplete clearable @click:clear="
                    $nextTick(() => {
                      showaddItem.tmstatusasoff = 0;
                    })
                    " v-model="showaddItem.tmstatusasoff" :items="tmstatus_list" item-text="tmupdatestatus_name"
                    item-value="tmupdatestatus_id" outlined @change="onSelectCustomerChange(showaddItem.tmstatusasoff)"
                    dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="9" md="9">
                  <h3>Remark</h3>
                  <v-textarea v-model="showaddItem.remark" multi-line outlined dense></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <div v-if="showaddItem.tm_type == 11">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-row>
                <v-col cols="12" sm="3" md="3">
                  <h3><span class="red--text">* </span>Receive Date</h3>
                  <v-menu v-model="menuReceive" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.receive_date" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          receive_date = parseDate(showaddItem.receive_date)
                          " @blur="
                            receive_date = parseDate(showaddItem.receive_date)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="receive_date" @input="
                      () => {
                        menuReceive = false;
                        calDateFinalDeadline();
                      }
                    "></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h3>Submit Date</h3>
                  <v-menu v-model="menuFilling" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.filling_date" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          filling_date = parseDate(showaddItem.filling_date)
                          " @blur="
                            filling_date = parseDate(showaddItem.filling_date)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="filling_date"
                      @input="onSelectfilling_dateTrademarkOppositionOthers"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h3><span class="red--text">* </span>Final Deadline</h3>
                  <v-menu v-model="menuStart" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.enddate" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          enddate = parseDate(showaddItem.enddate)
                          " @blur="enddate = parseDate(showaddItem.enddate)" append-icon="mdi-calendar" v-bind="attrs"
                        v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="enddate"
                      @input="onSelectFinalDeadlineTrademarkOppositionOthers"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h3><span class="red--text">* </span>Fixed Internal Date</h3>
                  <v-menu v-model="menuDeadline" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.internaldate" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          internaldate = parseDate(showaddItem.internaldate)
                          " @blur="
                            internaldate = parseDate(showaddItem.internaldate)
                            " v-bind="attrs" v-on="on" outlined dense disabled
                        background-color="#F5F5F5"></v-text-field>
                    </template>

                    <v-date-picker v-model="internaldate" @input="menuDeadline = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Upload Decision Document (อัปโหลดไฟลคำวินิจฉัย)</h3>
                </v-col>
              </v-row>
              <v-row class="mt-h" align="start">
                <v-col cols="12" sm="3" md="3">
                  <input type="file" ref="file_decision" multiple style="display: none" accept="application/pdf,.pdf"
                    @change="onFileChange('decision', $event)" />
                  <v-btn color="#254E58" dark block @click="$refs.file_decision.click()">
                    <v-icon left>mdi-cloud-upload</v-icon> Upload
                  </v-btn>
                  <ul v-if="fileList_decision.length" class="mt-3">
                    <li v-for="(file, i) in fileList_decision" :key="i">
                      <a :href="fileUrl(file)" target="_blank" class="pdf-link">{{ file.name }}</a>
                      <v-btn icon small color="red" @click="removeFile('decision', i)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </li>
                  </ul>
                </v-col>

                <v-col cols="0" sm="1" md="1" />

                <v-col cols="12" sm="6" md="4" style="margin-top: -20px">
                  <v-radio-group v-model="selectedOption" class="d-flex flex-column">
                    <v-radio class="small-radio custom-radio-label" label="Successful(สำเร็จ)" value="A"></v-radio>
                    <v-radio class="small-radio custom-radio-label" label="Unsuccessful(ไม่สำเร็จ)" value="B"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row class="mt-h">
                <v-col cols="12" sm="12" md="12" class="mt-2">
                  <h3>
                    Receive Date For Decision Document (วันที่รับคำวินิจฉัย)
                  </h3>
                </v-col>
              </v-row>
              <v-row class="mt-h">
                <v-col cols="12" sm="3" md="3">
                  <v-menu v-model="menuadd" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field clearable @click:clear="
                        $nextTick(() => {
                          showaddItem.date_of_regis = '';
                          date_of_regis = '';
                        })
                        " v-model="showaddItem.date_of_regis" persistent-hint @keydown.enter="
                          date_of_regis = parseDate(showaddItem.date_of_regis)
                          " @blur="
                            date_of_regis = parseDate(showaddItem.date_of_regis)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="date_of_regis" @input="menuadd = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-col cols="12" sm="3" md="3">
                  <h3>Trademark Status</h3>
                  <v-autocomplete clearable @click:clear="
                    $nextTick(() => {
                      showaddItem.tmstatusasoff = 0;
                    })
                    " v-model="showaddItem.tmstatusasoff" :items="tmstatus_list" item-text="tmupdatestatus_name"
                    item-value="tmupdatestatus_id" outlined @change="onSelectCustomerChange(showaddItem.tmstatusasoff)"
                    dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="9" md="9">
                  <h3>Remark</h3>
                  <v-textarea v-model="showaddItem.remark" multi-line outlined dense></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
        <div v-if="showTrademarkInfringementPoliceCustoms">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <h3>Goods / Service</h3>
                  <v-textarea v-model="showaddItem.good_service" multi-line outlined dense background-color="#F5F5F5"
                    disabled></v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-col cols="12" sm="3" md="3">
                  <h3><span class="red--text">* </span>Receive Date</h3>
                  <v-menu v-model="menuReceive" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.receive_date" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          receive_date = parseDate(showaddItem.receive_date)
                          " @blur="
                            receive_date = parseDate(showaddItem.receive_date)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="receive_date" @input="
                      () => {
                        menuReceive = false;
                        calDateFinalDeadline();
                      }
                    "></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <h3><span class="red--text">* </span>Submit Date</h3>
                  <v-menu v-model="menuFilling" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="showaddItem.filling_date" persistent-hint hint="Format DD/MM/YYYY"
                        @keydown.enter="
                          filling_date = parseDate(showaddItem.filling_date)
                          " @blur="
                            filling_date = parseDate(showaddItem.filling_date)
                            " append-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>

                    <v-date-picker v-model="filling_date" @input="menuFilling = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-col cols="12" sm="3" md="3">
                  <h3>Trademark Status</h3>
                  <v-autocomplete clearable @click:clear="
                    $nextTick(() => {
                      showaddItem.tmstatusasoff = 0;
                    })
                    " v-model="showaddItem.tmstatusasoff" :items="tmstatus_list" item-text="tmupdatestatus_name"
                    item-value="tmupdatestatus_id" outlined @change="onSelectCustomerChange(showaddItem.tmstatusasoff)"
                    dense></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="9" md="9">
                  <h3>Remark</h3>
                  <v-textarea v-model="showaddItem.remark" multi-line outlined dense></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn
          v-if="showFiling"
          depressed
          class="mr-3 buttongold"
          @click="saveaddItem('createDocket')"
        > -->
        <v-btn depressed class="mr-3 buttongold" @click="saveaddItem('createDocket')">
          Save and create docket
        </v-btn>
        <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveaddItem('create')"
          :disabled="disableCalculateNewRenewalDate">
          Save
        </v-btn>
        <v-btn depressed outlined width="100" @click="$router.back()">
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogconfirmdeleteattrecipt" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewreceipt">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deletedialogconfirmdeletereceipt">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete_cer" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete_cer">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm_cer">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteimage" max-width="550px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this image?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeleteimage">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirmimage">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteimageOpposed" max-width="550px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this image?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeleteimageOpposed">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirmimageOpposed">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewfile" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title>

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div v-if="checkfileapreview" v-for="(item, index) in previewpopupfile2" :key="index">
          <pdf :src="item" v-for="i in numPagespreview" :key="i" :id="i" :page="i">
            <template slot="loading"> loading content here... </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewfile">Cancel</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewimage" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewimage">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview Image</v-card-title>

        <v-img disabled :src="previewimage" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewimage">Cancel</v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogconfirmdeletenoticefile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closedialogconfirmdeletenoticefile">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deletedialogconfirmdeletenoticefile">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogconfirmdeleteattachfile" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closedialogconfirmdeleteattachfile">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deletedialogconfirmdeleteattachfile">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
const moment = require("moment-timezone");
import api from "@/services/api";
import {
  server,
  imagemasterTMUrl,
  filemasterTMUrl,
} from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";
export default {
  name: "About",
  data(vm) {
    return {
      sendBilling: "Reply All",
      sendBillingList: ["Reply All", "Specific Email", "Link"],
      sendBillingDetail: "",
      indexdeleteattreciept: -1,
      dialogconfirmdeleteattrecipt: false,
      customer_list: [],
      customer_selected: null,
      customer_address: "",

      disableCalculateNewRenewalDate: false,
      country_list: [],
      date_of_public: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_opposition: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_infringement: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_filling_appeal: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_filling_lawsuit: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_renewal: null,
      date_of_renewal_filed: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_deadline: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      dateof_filling_affidavits: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      dateof_filling_affidavits: null,
      endorsed_start: null,
      endorsed_end: null,
      date_of_regis: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_application: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_closed: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_issuing_certificate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      menudate_of_issuing_certificate: false,
      menudate_of_closed: false,
      dialogpreviewimage: false,
      checkfileapreview: false,
      previewpopupfile: [],
      previewpopupfile2: [],
      dialogpreviewfile: false,
      dialogDelete: false,
      dialogDeleteimage: false,
      fileindex: -1,
      preview_list2: [],
      getpreview_list: [],
      image: null,
      previewimage: null,
      previewimageedit: null,
      image_list: [],
      preview_list: [],
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      tmstatus_list: [],
      contact_owner_list: [],
      contact_agent_list: [],
      contact_associate_list: [],
      objecttype_list: [],
      filename: [],
      imagename: "",
      load_bg: false,
      checkfileadd: false,
      checkimageadd: false,
      page: 1,
      numPages: 0,
      numPagespreview: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      showaddItem: {
        agency: "",
        endorsed_start: null,
        endorsed_end: null,
        ref_search: 0,
        opposed_party: "",
        tm_type: 0,
        class_no: "",
        country: "",
        cliant_ref: "",
        name_of_client: "",
        file_no: "",
        regis_no: "",
        trademark: "",
        trademark: "",
        owner_contact: "",
        owner_address: "",
        agent_contact: 0,
        agent_address: "",
        agent_email: "",
        associate_contact: 0,
        associate_address: "",
        app_no: "",
        ir_no: "",
        good_service: "",
        condition_of_regis: "",
        val_no: "",
        page_no: "",
        tmstatusasoff: 0,
        dip_link: "",
        remark: "",
        date_of_public: "",
        date_of_opposition: "",
        date_of_infringement: "",
        date_of_filling_appeal: "",
        date_of_filling_lawsuit: "",
        date_of_regis: "",
        date_of_application: "",
        date_of_renewal: "",
        date_of_renewal_filed: "",
        date_of_filling: "",
        next_deadline: "",
        endorsed_start: "",
        dateof_filling_affidavits: "",
        endorsed_end: "",
        closed: false,
        disclaim: "",
        date_of_closed: "",
        date_of_issuing_certificate: "",
        user_create: localStorage.getItem(server.USER_ID),
        receive_date: null,
        filling_date: null,
        enddate: null,
        internaldate: null,
      },
      menuaddappdate: false,
      menupublication: false,
      menuopposition: false,
      menufilling_appeal: false,
      menufilling_lawsuit: false,
      menurenewal: false,
      menurenewal_filed: false,
      menuaffidavits: false,
      menufiling_affidavits: false,
      menufiling_endorsed_start: false,
      menufiling_endorsed_end: false,
      menuadd: false,
      fullPage: true,
      datefrom: vm.formatDate(new Date().toISOString().substr(0, 10)),
      dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      search: "",
      mDataArray: [],
      sostatus: false,
      owner_contact_list: [],
      showFiling: false,
      showIsSearch: false,
      showTrademarkOhter: false,
      showTrademarkInfringementPoliceCustoms: false,
      priorityList: [
        {
          number: "",
          date: "",
          country: "",
          menu: false,
        },
      ],
      images: [],
      previews: [],
      imagenames: [],
      indexDelImage: -1,
      carouselIndex: 0,
      carouselIndexOpposed: 0,

      imagesOpposed: [],
      previewsOpposed: [],
      imagenamesOpposed: [],
      checkimageaddOpposed: false,
      dialogDeleteimageOpposed: false,
      indexDelImageOpposed: -1,

      //cer
      preview_list_cer: [], // เก็บ task ของ PDF preview
      image_list_cer: [], // เก็บไฟล์ PDF/รูป
      filename_cer: [], // ชื่อไฟล์
      getpreview_list_cer: [], // เก็บ base64 ของไฟล์ PDF/รูป
      preview_list2_cer: [], // สำรอง preview list
      checkfileeadd_cer: false, // ใช้ตรวจสอบว่ามีไฟล์อัพโหลดหรือไม่
      checkfileadd_cer: false, // ใช้ตรวจสอบว่า PDF preview โหลดเสร็จหรือยัง
      numPages_cer: 0, // จำนวนหน้า PDF
      page_cer: 1,
      fileindex_cer: -1,
      dialogDelete_cer: false,

      filling_date: null,
      receive_date: null,
      enddate: null,
      internaldate: null,
      menuReceive: false,
      menuFilling: false,
      menuStart: false,
      menuDeadline: false,
      fileList_search: [],
      fileList_submitted: [],
      fileList_notice: [],
      fileList_receipt: [],
      fileList_good_service: [],
      fileList_decision: [],
      selectedOption: null,
      Agency_list: [
        "กรมสอบสวนคดีพิเศษ (DSI.)",
        "ศูนย์ปราบปรามการละเมิดทรัพย์สินทางปัญญา (ศปลป.ตร.) สำนักงานตำรวจแห่งชาติ",
        "กองบังคับการปราบปรามการกระทำความผิดเกี่ยวกับอาชญากรรมทางเศรษฐกิจ (ปอศ) สำนักงานตำรวจแห่งชาติ",
        "กรมศุลกากร",
      ],

      dataFileAll: [],
      getpreview_listnotice: [],
      preview_listnotice: [],
      preview_listnotice2: [],
      image_listnotice: [],
      filenamenotice: [],
      checkfilenotice: false,
      dialogconfirmdeletenoticefile: false,
      indexdeleteattachfilelist: -1,
      dialogconfirmdeleteattachfile: false,
      indexdeleteattachfile: -1,
      getpreview_listattach: [],
      preview_listattach: [],
      preview_listattach2: [],
      image_listattach: [],
      filenameattach: [],
      checkfileattach: false,

      decisionBoxes: [
        { files: [], date: "", level: 1, menuReceiveBox: false, result: "" },
      ],
      labels: [
        // "อัปโหลดไฟล์คำวินิจฉัยของนายทะเบียน",
        // "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
        // "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
      ],
      labelsDecripnt: [
        // "วันที่รับคำวินิจฉัยของนายทะเบียน",
        // "วันที่รับคำวินิจฉัยของชั้นคณะกรรมการ",
        // "วันที่รับคำวินิจฉัยไปศาล",
      ],
      ref_search_list: [],
      getpreview_listreceipt: [],
      preview_listrecicpt: [],
      preview_listrecipt2: [],
      image_listrecicpt: [],
      filenamerecive: [],
    };
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    pdf: pdfvuer,
  },
  async mounted() {
    await this.loaddataobjecttypeBygroupId();
    await this.loadfilenoSearch();
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();
    await this.loaddatacountry();
    await this.loaddatatmupdatestatus();
    await this.loadCustomerComboboxMetter();
    this.$hideLoader();
  },

  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },
    date_of_regis(val) {
      this.showaddItem.date_of_regis = this.formatDate(this.date_of_regis);
    },
    date_of_application(val) {
      this.showaddItem.date_of_application = this.formatDate(
        this.date_of_application
      );
    },
    date_of_public(val) {
      this.showaddItem.date_of_public = this.formatDate(this.date_of_public);
    },
    date_of_opposition(val) {
      this.showaddItem.date_of_opposition = this.formatDate(
        this.date_of_opposition
      );
    },
    date_of_infringement(val) {
      this.showaddItem.date_of_infringement = this.formatDate(
        this.date_of_infringement
      );
    },
    date_of_filling_appeal(val) {
      this.showaddItem.date_of_filling_appeal = this.formatDate(
        this.date_of_filling_appeal
      );
    },
    date_of_filling_lawsuit(val) {
      this.showaddItem.date_of_filling_lawsuit = this.formatDate(
        this.date_of_filling_lawsuit
      );
    },
    date_of_renewal(val) {
      this.showaddItem.date_of_renewal = this.formatDate(this.date_of_renewal);
    },
    date_of_renewal_filed(val) {
      this.showaddItem.date_of_renewal_filed = this.formatDate(
        this.date_of_renewal_filed
      );
    },

    next_deadline(val) {
      this.showaddItem.next_deadline = this.formatDate(this.next_deadline);
    },
    dateof_filling_affidavits(val) {
      this.showaddItem.dateof_filling_affidavits = this.formatDate(
        this.dateof_filling_affidavits
      );
    },
    endorsed_start(val) {
      this.showaddItem.endorsed_start = this.formatDate(this.endorsed_start);
    },
    endorsed_end(val) {
      this.showaddItem.endorsed_end = this.formatDate(this.endorsed_end);
    },
    date_of_closed(val) {
      this.showaddItem.date_of_closed = this.formatDate(this.date_of_closed);
    },
    date_of_issuing_certificate(val) {
      this.showaddItem.date_of_issuing_certificate = this.formatDate(
        this.date_of_issuing_certificate
      );
    },
    receive_date(val) {
      this.showaddItem.receive_date = this.formatDate(this.receive_date);
    },
    filling_date(val) {
      this.showaddItem.filling_date = this.formatDate(this.filling_date);
    },
    startdate(val) {
      this.showaddItem.startdate = this.formatDate(this.startdate);
    },
    enddate(val) {
      this.showaddItem.enddate = this.formatDate(this.enddate);
    },
    internaldate(val) {
      this.showaddItem.internaldate = this.formatDate(this.internaldate);
    },
  },
  methods: {
    async deletedialogconfirmdeletereceipt() {
      this.filenamerecive.splice(this.indexdeleteattreciept, 1);
      this.getpreview_listreceipt.splice(this.indexdeleteattreciept, 1);
      this.preview_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.image_listrecicpt.splice(this.indexdeleteattreciept, 1);
      this.dialogconfirmdeleteattrecipt = false;
    },
    async closepreviewreceipt(index) {
      this.indexdeleteattreciept = -1;
      this.dialogconfirmdeleteattrecipt = false;
    },
    async confirmdeleteattreceipt(index) {
      this.indexdeleteattreciept = index;
      this.dialogconfirmdeleteattrecipt = true;
    },
    async previewreceiptfile(index) {
      if (this.filenamerecive[index].split(/[\s.]+/).pop() == "pdf") {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `
          <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${this.getpreview_listreceipt[index]}" title="PDF Preview"></iframe>
              </body>
            </html>
            `
        );

        return;
      } else {
        this.previewreceipt = this.getpreview_listreceipt[index];
        // this.dialogpreviewattachimage = true;
        const imageTab = window.open("");
        imageTab.document.write(`
          <html>
            <head>
              <title>Preview Image</title>
            </head>
            <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
              <img src="${this.previewreceipt}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            </body>
          </html>
        `);
        return;
      }
    },
    //onChanege customer filter full_address by id
    async onSelectComboboxMetterChange(value) {
      // console.log(`onSelectComboboxMetterChange: ${value}`);
      const selectedCustomer = this.customer_list.find(
        (customer) => customer.id === value
      );
      this.customer_address = selectedCustomer
        ? selectedCustomer.full_address
        : "";
    },
    async loadCustomerComboboxMetter() {
      const result = await api.getCustomerComboboxByMetter(
        localStorage.getItem(server.COMPANYID)
      );
      // console.log(`loadCustomerComboboxMetter: ${JSON.stringify(result.data)}`);

      this.customer_list = result.data;
    },

    async loadfilenoSearch() {
      var resFileNoSearch = await api.gteTMFileNoSearch();
      if (resFileNoSearch.data.length > 0) {
        this.ref_search_list = resFileNoSearch.data;
      }
    },
    removeFileBox(boxIndex, fileIndex) {
      this.decisionBoxes[boxIndex].files.splice(fileIndex, 1);
    },
    async previewBoxfile(index, fIndex) {
      var dataBoxFile = this.decisionBoxes[index].files[fIndex];
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = e.target.result;
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(`
            <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${fileData}" title="PDF Preview"></iframe>
              </body>
            </html>
          `);
        pdf_newTab.document.close();
      };
      // ตรงนี้ต้องใช้ dataBoxFile ไม่ใช่ checkfile
      reader.readAsDataURL(dataBoxFile);
    },
    async previewattachfile(index) {
      if (this.filenameattach[index].split(/[\s.]+/).pop() == "pdf") {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(
          `
          <html>
              <head>
                <title>PDF Preview</title>
                <style>
                  html, body {
                    margin: 0;
                    height: 100%;
                    overflow: hidden;
                  }
                  iframe {
                    border: none;
                    width: 100%;
                    height: 100%;
                  }
                </style>
              </head>
              <body>
                <iframe src="${this.getpreview_listattach[index]}" title="PDF Preview"></iframe>
              </body>
            </html>
            `
        );

        return;
      } else {
        this.previewattachimage = this.getpreview_listattach[index];
        // this.dialogpreviewattachimage = true;
        const imageTab = window.open("");
        imageTab.document.write(`
          <html>
            <head>
              <title>Preview Image</title>
            </head>
            <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
              <img src="${this.previewattachimage}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
            </body>
          </html>
        `);
        return;
      }
    },
    triggerUpload(index) {
      // ใช้ refs แบบ array
      const input = this.$refs.fileInputs[index];
      if (input) input.click();
    },
    formatDateToDMY(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    addBox(index) {
      this.decisionBoxes.push({
        files: [],
        date: "",
        menuReceiveBox: false,
        result: "",
        level: index + 2,
      });
    },
    removeBox(index) {
      this.decisionBoxes.splice(index, 1);
    },
    onFileChange(type, event) {
      const files = Array.from(event.target.files);

      // กำหนด allowed types ตาม type
      let allowedTypes = [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
      ];

      if (type === "good_service") allowedTypes = ["text/csv"];
      if (type === "decision") allowedTypes = ["application/pdf"];

      const newFiles = files.filter((file) => {
        if (type === "good_service") {
          return (
            allowedTypes.includes(file.type) ||
            file.name.toLowerCase().endsWith(".csv")
          );
        } else if (type === "decision") {
          return (
            allowedTypes.includes(file.type) ||
            file.name.toLowerCase().endsWith(".pdf")
          );
        } else {
          return (
            allowedTypes.includes(file.type) ||
            file.name.toLowerCase().endsWith(".doc") ||
            file.name.toLowerCase().endsWith(".docx") ||
            file.name.toLowerCase().endsWith(".pdf")
          );
        }
      });

      if (!newFiles.length) {
        let msg = "กรุณาเลือกไฟล์ Word หรือ PDF";
        if (type === "good_service") msg = "กรุณาเลือกไฟล์ CSV เท่านั้น";
        if (type === "decision") msg = "กรุณาเลือกไฟล์ PDF เท่านั้น";
        alert(msg);
        return;
      }

      // เลือก list ของ type
      let list;
      if (type === "search") list = this.fileList_search;
      else if (type === "submitted") list = this.fileList_submitted;
      else if (type === "notice") list = this.fileList_notice;
      else if (type === "receipt") list = this.fileList_receipt;
      else if (type === "good_service") list = this.fileList_good_service;
      else if (type === "decision") list = this.fileList_decision;

      list.push(...newFiles);

      // เรียง PDF ก่อน สำหรับ good_service ไม่มี PDF จึงไม่กระทบ
      list.sort((a, b) => {
        const isPdfA = a.name.toLowerCase().endsWith(".pdf");
        const isPdfB = b.name.toLowerCase().endsWith(".pdf");
        if (isPdfA && !isPdfB) return -1;
        if (!isPdfA && isPdfB) return 1;
        return 0;
      });

      event.target.value = "";
    },

    removeFile(type, index) {
      let list;
      if (type === "search") list = this.fileList_search;
      else if (type === "submitted") list = this.fileList_submitted;
      else if (type === "notice") list = this.fileList_notice;
      else if (type === "receipt") list = this.fileList_receipt;
      else if (type === "good_service") list = this.fileList_good_service;
      else if (type === "decision") list = this.fileList_decision;

      list.splice(index, 1);
    },

    fileUrl(file) {
      return URL.createObjectURL(file);
    },

    onSelectNextRenewalDate(value) {
      // value = "YYYY-MM-DD"
      this.menurenewal = false;

      // set Next Renewal Date
      this.showaddItem.date_of_renewal = this.formatDate(value);

      // คำนวณ -90 วัน
      const date = new Date(value); // แปลงเป็น Date object
      date.setDate(date.getDate() - 90);

      // แปลงกลับเป็น DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      this.showaddItem.date_of_renewal_filed = `${day}/${month}/${year}`;
    },
    onSelectFinalDeadlineSearch(value) {
      if (Number(this.showaddItem.tm_type) == 6) {
        // value = "YYYY-MM-DD"
        this.menuStart = false;

        // set Next Renewal Date
        this.showaddItem.enddate = this.formatDate(value);

        // คำนวณ -7 วัน
        const date = new Date(value); // แปลงเป็น Date object
        date.setDate(date.getDate() - 7);

        // แปลงกลับเป็น DD/MM/YYYY
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        this.showaddItem.internaldate = `${day}/${month}/${year}`;
      } else {
        // value = "YYYY-MM-DD"
        this.menuStart = false;

        // set Next Renewal Date
        this.showaddItem.enddate = this.formatDate(value);

        // คำนวณ -90 วัน
        const date = new Date(value); // แปลงเป็น Date object
        date.setDate(date.getDate() - 7);

        // แปลงกลับเป็น DD/MM/YYYY
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        this.showaddItem.internaldate = `${day}/${month}/${year}`;
      }
    },
    onSelectFinalDeadlineTrademarkOppositionOthers(value) {
      // value = "YYYY-MM-DD"
      this.menuStart = false;

      // set Next Renewal Date
      this.showaddItem.enddate = this.formatDate(value);

      // แปลงเป็น Date object
      const date = new Date(value);

      // ลบ 1 เดือน ตามปฏิทิน
      const currentMonth = date.getMonth();
      date.setMonth(currentMonth - 1);

      // แปลงกลับเป็น DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      this.showaddItem.internaldate = `${day}/${month}/${year}`;
    },
    onSelectfilling_dateTrademarkOppositionOthers(value) {
      // value = "YYYY-MM-DD"
      this.menuFilling = false;

      // set filling_date
      this.showaddItem.filling_date = this.formatDate(value);

      // แปลงเป็น Date object
      const date = new Date(value);

      // บวก 60 วัน
      date.setDate(date.getDate() + 60);

      // แปลงกลับเป็น DD/MM/YYYY
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      this.showaddItem.enddate = `${day}/${month}/${year}`;

      // เรียก onSelectFinalDeadlineTrademarkOppositionOthers ต่อ
      // แปลงเป็น YYYY-MM-DD สำหรับส่ง
      const nextValue = `${year}-${month}-${day}`;
      this.onSelectFinalDeadlineTrademarkOppositionOthers(nextValue);
    },
    setDefluatData() {
      this.showaddItem.date_of_renewal = "";
      this.showaddItem.date_of_renewal_filed = "";
      this.date_of_renewal = "";
      this.date_of_renewal_filed = "";

      //upload trademark image
      this.images = [];
      this.imagenames = [];
      this.previews = [];
      this.checkimageadd = false;

      //upload file
      this.image_list = [];
      this.filename = [];
      this.getpreview_list = [];
      this.preview_list = [];
      this.preview_list2 = [];
      this.checkfileeadd = false;

      //upload cer
      this.image_list_cer = [];
      this.filename_cer = [];
      this.getpreview_list_cer = [];
      this.preview_list_cer = [];
      this.preview_list2_cer = [];
      this.checkfileeadd_cer = false;

      //search file
      this.fileList_search = [];
    },
    calDateFinalDeadline() {
      if (Number(this.showaddItem.tm_type) == 6) {
      } else {
        const [year, month, day] = this.receive_date.split("-").map(Number);
        const date = new Date(year, month - 1, day);

        // คำนวณ enddate = receive_date + 5 ปี - 1 วัน
        date.setFullYear(date.getFullYear() + 5);
        date.setDate(date.getDate() - 1);

        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        this.showaddItem.enddate = `${d}/${m}/${y}`;

        // internaldate = enddate - 7 วัน
        const internalDate = new Date(date);
        internalDate.setDate(internalDate.getDate() - 7);

        const iy = internalDate.getFullYear();
        const im = String(internalDate.getMonth() + 1).padStart(2, "0");
        const id = String(internalDate.getDate()).padStart(2, "0");
        this.showaddItem.internaldate = `${id}/${im}/${iy}`;
      }
    },
    formatDatePriority(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateInputPriority(value) {
      if (!value) return "";
      const parts = value.split("/");
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return value; // fallback ถ้า format ไม่ถูกต้อง
    },
    addPriority() {
      this.priorityList.push({
        number: "",
        date: "",
        country: "",
        menu: false,
      });
    },
    removePriority(index) {
      this.priorityList.splice(index, 1);
    },

    async saveaddItem(modeOper) {
      if (this.showaddItem.tm_type == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Object Type Data",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.file_no == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter File No. Data",
          "text-h5 red--text text-center"
        );
        return;
      }

      var checkfileNo = await api.CheckTMFileNo(this.showaddItem.file_no);
      if (checkfileNo.data.length > 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Data Duplicate ",
          "Please check File No.",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (Number(this.showaddItem.tm_type) == 6) {
        if (!this.showaddItem.receive_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Receive Date",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.showaddItem.enddate) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Final Deadline",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.showaddItem.internaldate) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Fixed Internal Date",
            "text-h5 red--text text-center"
          );
          return;
        }
      } else if (Number(this.showaddItem.tm_type) == 10) {
        if (!this.showaddItem.receive_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Receive Date",
            "text-h5 red--text text-center"
          );
          return;
        }
        for (const [index, item] of this.decisionBoxes.entries()) {
          if (!item.date || !item.result) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Check data",
              "Please Put Decision Document Data",
              "text-h5 red--text text-center"
            );
            return; // ออกจากฟังก์ชันทันที
          }
        }
      } else if (
        Number(this.showaddItem.tm_type) == 7 ||
        Number(this.showaddItem.tm_type) == 8
      ) {
        if (this.showaddItem.app_no.trim() != "") {
          var checkAppno = await api.CheckTMAppNp(this.showaddItem.app_no);
          if (checkAppno.data.length > 0) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Data Duplicate ",
              "Please check Application No.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
        if (
          Number(this.showaddItem.tm_type) != 7) {
          for (const [index, item] of this.decisionBoxes.entries()) {
            if (!item.date || !item.result) {
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Check data",
                "Please Put Decision Document Data",
                "text-h5 red--text text-center"
              );
              return; // ออกจากฟังก์ชันทันที
            }
          }
        }
      } else if (Number(this.showaddItem.tm_type) == 9) {
        if (this.showaddItem.app_no.trim() != "") {
          var checkAppno = await api.CheckTMAppNp(this.showaddItem.app_no);
          if (checkAppno.data.length > 0) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Data Duplicate ",
              "Please check Application No.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
        if (!this.showaddItem.receive_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Receive Date",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.showaddItem.filling_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Submit Date",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      var dataAdd = {
        ref_search: 0,
        file_no: "",
        regis_no: "",
        tm_type: 0,
        class_no: "",
        country: "",
        master_images: "",
        master_files: "",
        date_of_filling: null,
        name_of_client: "",
        date_of_regis: null,
        cliant_ref: "",
        app_no: "",
        date_of_application: null,
        trademark: "",
        owner_contact: "",
        agent_contact: 0,
        associate_contact: 0,
        date_of_public: null,
        date_of_filling_appeal: null,
        good_service: "",
        val_no: "",
        date_of_filling_lawsuit: null,
        remark: "",
        page_no: "",
        date_of_renewal: null,
        condition_of_regis: "",
        date_of_opposition: null,

        date_of_renewal_filed: null,
        last_update: null,
        next_deadline: null,
        dateof_filling_affidavits: null,
        lawyer: "",
        tmstatusasoff: 0,
        dip_link: "",
        key_by: "",
        images_update: null,
        updatestatus: 0,
        madrid: 0,
        recordal: 0,
        recordalstatus: 0,
        provisional: 0,
        closed: 0,
        disclaim: "",
        date_of_closed: null,
        date_of_issuing_certificate: 0,
        created_at: null,
        updated_at: null,
        user_create: null,
        user_create: null,
        user_update: null,

        receive_date: null,
        filling_date: null,
        enddate: null,
        internaldate: null,
        endorsed_start: null,
        endorsed_end: null,
        ir_no: "",
        opposed_party: "",
        cus_billing_id: null,
        date_of_infringement: null,
        agency: "",
        send_billing: "",
        send_billing_detail: "",
      };

      //set all data
      dataAdd.cus_billing_id = this.customer_selected
        ? this.customer_selected
        : null;
      dataAdd.send_billing = this.sendBilling;
      if (this.sendBilling == "Reply All") {
        dataAdd.send_billing_detail = "";
      } else {
        dataAdd.send_billing_detail = this.sendBillingDetail;
      }

      dataAdd.file_no = this.showaddItem.file_no.trim();
      dataAdd.tm_type = Number(this.showaddItem.tm_type);
      dataAdd.country = this.showaddItem.country.trim();
      dataAdd.app_no = this.showaddItem.app_no.trim();
      dataAdd.trademark = this.showaddItem.trademark.trim();
      dataAdd.class_no = this.showaddItem.class_no.trim();
      if (this.owner_contact_list.length > 0) {
        dataAdd.owner_contact = this.owner_contact_list
          .map((item) => item.contact_id)
          .join(",");

        dataAdd.name_of_client = this.owner_contact_list
          .map((item) => item.contact_name)
          .join(", ");
      }

      dataAdd.cliant_ref = this.showaddItem.cliant_ref;
      dataAdd.agent_contact = this.showaddItem.agent_contact;
      dataAdd.associate_contact = this.showaddItem.associate_contact;
      dataAdd.tmstatusasoff = this.showaddItem.tmstatusasoff;
      dataAdd.last_update = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);

      dataAdd.images_update = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .replace("T", " ")
        .substr(0, 19);
      dataAdd.remark = this.showaddItem.remark;
      dataAdd.user_create = Number(localStorage.getItem(server.USER_ID));

      if (
        Number(this.showaddItem.tm_type) == 1 ||
        Number(this.showaddItem.tm_type) == 3
      ) {
        dataAdd.ir_no = this.showaddItem.ir_no;
        dataAdd.date_of_application = this.changeformatDatetoinsert(
          this.showaddItem.date_of_application
        );
        dataAdd.date_of_public = this.changeformatDatetoinsert(
          this.showaddItem.date_of_public
        );
        dataAdd.regis_no = this.showaddItem.regis_no;
        dataAdd.date_of_regis = this.changeformatDatetoinsert(
          this.showaddItem.date_of_regis
        );
        dataAdd.date_of_issuing_certificate = this.changeformatDatetoinsert(
          this.showaddItem.date_of_issuing_certificate
        );
        dataAdd.date_of_renewal_filed = this.changeformatDatetoinsert(
          this.showaddItem.date_of_renewal_filed
        );
        dataAdd.date_of_renewal = this.changeformatDatetoinsert(
          this.showaddItem.date_of_renewal
        );
        dataAdd.good_service = this.showaddItem.good_service;
        dataAdd.ref_search = this.showaddItem.ref_search;
        if (Number(this.showaddItem.tm_type) == 3) {
          dataAdd.endorsed_start = this.changeformatDatetoinsert(
            this.showaddItem.endorsed_start
          );
          dataAdd.endorsed_end = this.changeformatDatetoinsert(
            this.showaddItem.endorsed_end
          );
          dataAdd.dateof_filling_affidavits = this.changeformatDatetoinsert(
            this.showaddItem.dateof_filling_affidavits
          );
        }
      } else if (Number(this.showaddItem.tm_type) == 6) {
        dataAdd.receive_date = this.changeformatDatetoinsert(
          this.showaddItem.receive_date
        );
        dataAdd.filling_date = this.changeformatDatetoinsert(
          this.showaddItem.filling_date
        );
        dataAdd.enddate = this.changeformatDatetoinsert(
          this.showaddItem.enddate
        );
        dataAdd.internaldate = this.changeformatDatetoinsert(
          this.showaddItem.internaldate
        );
      } else if (Number(this.showaddItem.tm_type) == 10) {
        dataAdd.receive_date = this.changeformatDatetoinsert(
          this.showaddItem.receive_date
        );
        dataAdd.filling_date = this.changeformatDatetoinsert(
          this.showaddItem.filling_date
        );
        dataAdd.good_service = this.showaddItem.good_service;

        dataAdd.date_of_application = dataAdd.receive_date;
      } else if (
        Number(this.showaddItem.tm_type) == 7 ||
        Number(this.showaddItem.tm_type) == 8
      ) {
        dataAdd.ir_no = this.showaddItem.ir_no;
        dataAdd.date_of_application = this.changeformatDatetoinsert(
          this.showaddItem.date_of_application
        );

        dataAdd.opposed_party = this.showaddItem.opposed_party;
        dataAdd.date_of_opposition = this.changeformatDatetoinsert(
          this.showaddItem.date_of_opposition
        );
        dataAdd.good_service = this.showaddItem.good_service;
      } else if (Number(this.showaddItem.tm_type) == 9) {
        dataAdd.ir_no = this.showaddItem.ir_no;

        dataAdd.date_of_application = this.changeformatDatetoinsert(
          this.showaddItem.date_of_application
        );
        dataAdd.date_of_infringement = this.changeformatDatetoinsert(
          this.showaddItem.date_of_infringement
        );
        dataAdd.agency = this.showaddItem.agency;
        dataAdd.receive_date = this.changeformatDatetoinsert(
          this.showaddItem.receive_date
        );
        dataAdd.filling_date = this.changeformatDatetoinsert(
          this.showaddItem.filling_date
        );

        if (this.fileList_good_service.length > 0) {
          for (const file of this.fileList_good_service) {
            const csvText = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = (e) => resolve(e.target.result);
              reader.onerror = (err) => reject(err);
              reader.readAsText(file); // อ่านเป็น text
            });

            // แปลง CSV เป็น array ของ object (สมมติว่า CSV มี header)
            const lines = csvText
              .split(/\r?\n/)
              .filter((line) => line.trim() !== "");
            const headers = lines[0].split(",").map((h) => h.trim());
            const dataRows = lines.slice(1).map((line) => {
              const values = line.split(",").map((v) => v.trim());
              const obj = {};
              headers.forEach((h, i) => {
                obj[h] = values[i] ?? null;
              });
              return obj;
            });

            // จัดกลุ่ม product ตาม class
            const grouped = dataRows.reduce((acc, item) => {
              if (!acc[item.class]) acc[item.class] = [];
              acc[item.class].push(item.product);
              return acc;
            }, {});

            // สร้าง string แสดง class + product
            const classKeys = Object.keys(grouped);
            let resultHTML = "";

            classKeys.forEach((cls, idx) => {
              const products = grouped[cls];
              const productStr =
                products.length > 1 ? products.join(", ") : products[0];

              resultHTML += `${cls}: ${productStr}`;
              // ใส่ <br /> เฉพาะถ้าไม่ใช่ class ตัวสุดท้าย
              if (idx !== classKeys.length - 1) resultHTML += "<br />";
            });

            dataAdd.good_service = resultHTML;
          }
        }
      }
      var main_master_id = 0;
      try {
        this.$showLoader();
        var resadddata = await api.CreateNewTm(dataAdd);

        if (resadddata.status == 201) {
          main_master_id = resadddata.data.mastertm_id;
          if (this.image_listnotice.length > 0) {
            this.image_listnotice.forEach(async (item) => {
              let formData = new FormData();
              formData.set("file", item);
              formData.set("fileName", item.name);
              formData.set("fileTypeAdd", `notice`);
              await api.CreateFileMatterTm(Number(main_master_id), formData);
            });
          }
          if (this.image_listattach.length > 0) {
            this.image_listattach.forEach(async (item) => {
              let formData = new FormData();
              formData.set("file", item);
              formData.set("fileName", item.name);
              formData.set("fileTypeAdd", `attach`);
              await api.CreateFileMatterTm(Number(main_master_id), formData);
            });
          }
          if (this.images.length > 0) {
            this.images.forEach(async (item) => {
              let formData = new FormData();
              formData.set("file", item);
              formData.set("fileName", item.name);
              formData.set("fileTypeAdd", `image`);
              await api.CreateFileMatterTm(Number(main_master_id), formData);
            });
          }

          if (this.imagesOpposed.length > 0) {
            this.imagesOpposed.forEach(async (item) => {
              let formData = new FormData();
              formData.set("file", item);
              formData.set("fileName", item.name);
              if (Number(this.showaddItem.tm_type) == 7) {
                formData.set("fileTypeAdd", `image_opposed`);
              } else if (Number(this.showaddItem.tm_type) == 8) {
                formData.set("fileTypeAdd", `image_cancellation`);
              }

              await api.CreateFileMatterTm(Number(main_master_id), formData);
            });
          }
          if (
            this.showaddItem.tm_type == 1 ||
            Number(this.showaddItem.tm_type) == 3
          ) {
            if (this.image_list.length > 0) {
              this.image_list.forEach(async (item) => {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                formData.set("fileTypeAdd", `filing_file`);
                await api.CreateFileMatterTm(Number(main_master_id), formData);
              });
            }
            if (this.image_list_cer.length > 0) {
              this.image_list_cer.forEach(async (item) => {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                formData.set("fileTypeAdd", `filing_cer`);
                await api.CreateFileMatterTm(Number(main_master_id), formData);
              });
            }
            for (const [index, item] of this.priorityList.entries()) {
              var data_add_riority = {
                masterpt_id: Number(main_master_id),
                priority_number: item.number,
                priority_date: item.date,
                priority_country: item.country,
                master_type: `MasterTM`,
              };
              if (item.number != "" || item.date != "" || item.country != "") {
                await api.createMASTERPT_PRIORITY(data_add_riority);
              }
            }
          }
          if (
            this.showaddItem.tm_type == 8 ||
            this.showaddItem.tm_type == 10
          ) {
            for (const [index, item] of this.decisionBoxes.entries()) {
              var dataDecisionDocumentAdd = {
                appointment_id: Number(main_master_id),
                level: item.level,
                result: item.result,
                date: item.date,
                type: `matterTM`,
              };
              await api.createdecision(dataDecisionDocumentAdd);
              if (item.files.length > 0) {
                for (const file of item.files) {
                  let formData = new FormData();
                  formData.set("file", file);
                  formData.set("fileName", file.name);
                  formData.set("fileTypeAdd", `decision_level${item.level}`);
                  await api.CreateFileMatterTm(
                    Number(main_master_id),
                    formData
                  );
                }
              }
            }
          }
          if (this.showaddItem.tm_type == 6) {
            if (this.image_listrecicpt.length > 0) {
              this.image_listrecicpt.forEach(async (item) => {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                formData.set("fileTypeAdd", `recicpt`);
                await api.CreateFileMatterTm(Number(main_master_id), formData);
              });
            }
          }
          if (this.showaddItem.tm_type == 9 || this.showaddItem.tm_type == 10) {
            if (this.image_listrecicpt.length > 0) {
              this.image_listrecicpt.forEach(async (item) => {
                let formData = new FormData();
                formData.set("file", item);
                formData.set("fileName", item.name);
                formData.set("fileTypeAdd", `recicpt`);
                await api.CreateFileMatterTm(Number(main_master_id), formData);
              });
            }
            if (this.showaddItem.tm_type != 10) {
              if (this.fileList_good_service.length > 0) {
                this.fileList_good_service.forEach(async (item) => {
                  let formData = new FormData();
                  formData.set("file", item);
                  formData.set("fileName", item.name);
                  formData.set("fileTypeAdd", `good_service`);
                  await api.CreateFileMatterTm(
                    Number(main_master_id),
                    formData
                  );
                });
              }
            }
          }
          var dataAdd = {
            user_id: localStorage.getItem(server.USER_ID),
            log_in_out_id: localStorage.getItem(server.LOGIN_ID),
            action: "Create",
            table_name: "mastertm",
            table_id: main_master_id,
            date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          };
          await api.addTransectionLogCoreApi(dataAdd);
          var dataEditLog = {
            last_update: moment()
              .tz("Asia/Bangkok")
              .format("YYYY-MM-DD HH:mm:ss"),
          };
          await api.updateLogInOutLog(
            localStorage.getItem(server.LOGIN_ID),
            dataEditLog
          );
          this.$hideLoader();
          if (modeOper == "createDocket") {
            this.dialogAddmastertm = false;
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              `/appointmenttm-add/${this.showaddItem.file_no}/null`
            );
            return;
          } else {
            this.dialogAddmastertm = false;
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              "/master-trademark-list"
            );
            return;
          }
        }
      } catch (error) {
        this.$hideLoader(); // ซ่อน loader ถ้ามี
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          false,
          "save data",
          "save data failed: ",
          "text-h5 red--text text-center",
          null
        );
      }
    },

    async saveandcreateappointmentaddItem() {
      if (this.showaddItem.tm_type == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Object Type Data",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.file_no == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter File No. Data",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.showaddItem.trademark == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Trademark Data",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (
        !this.showaddItem.date_of_application ||
        this.showaddItem.date_of_application == ""
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Application Date Data",
          "text-h5 red--text text-center"
        );
        return;
      }

      if (
        this.showaddItem.closed == true &&
        this.showaddItem.date_of_closed == ""
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter Closed File Date Data",
          "text-h5 red--text text-center"
        );
        return;
      }

      this.$showLoader();
      let formData = new FormData();
      formData.append(`file`, this.image);
      this.image_list.forEach((x, index) => {
        formData.append(`file`, x);
      });
      formData.append("file_no", this.showaddItem.file_no.trim());
      formData.append("regis_no", this.showaddItem.regis_no.trim());
      formData.append("tm_type", this.showaddItem.tm_type);
      formData.append("class_no", this.showaddItem.class_no.trim());
      formData.append("country", this.showaddItem.country.trim());
      // formData.append("date_of_filling", this.showaddItem.date_of_filling);
      formData.append("name_of_client", this.showaddItem.name_of_client.trim());
      if (
        this.showaddItem.date_of_regis !== "" &&
        this.showaddItem.date_of_regis !== null
      ) {
        formData.append(
          "date_of_regis",
          this.changeformatDatetoinsert(this.showaddItem.date_of_regis)
        );
      }
      formData.append("cliant_ref", this.showaddItem.cliant_ref.trim());
      formData.append("app_no", this.showaddItem.app_no.trim());
      if (
        this.showaddItem.date_of_application !== "" &&
        this.showaddItem.date_of_application !== null
      ) {
        formData.append(
          "date_of_application",
          this.changeformatDatetoinsert(this.showaddItem.date_of_application)
        );
      }
      formData.append("trademark", this.showaddItem.trademark.trim());
      formData.append("owner_contact", this.showaddItem.owner_contact);
      formData.append("agent_contact", this.showaddItem.agent_contact);
      formData.append("associate_contact", this.showaddItem.associate_contact);
      if (
        this.showaddItem.date_of_public !== "" &&
        this.showaddItem.date_of_public !== null
      ) {
        formData.append(
          "date_of_public",
          this.changeformatDatetoinsert(this.showaddItem.date_of_public)
        );
      }
      if (
        this.showaddItem.date_of_filling_appeal !== "" &&
        this.showaddItem.date_of_filling_appeal !== null
      ) {
        formData.append(
          "date_of_filling_appeal",
          this.changeformatDatetoinsert(this.showaddItem.date_of_filling_appeal)
        );
      }
      formData.append("good_service", this.showaddItem.good_service.trim());
      formData.append("val_no", this.showaddItem.val_no.trim());
      if (
        this.showaddItem.date_of_filling_lawsuit !== "" &&
        this.showaddItem.date_of_filling_lawsuit !== null
      ) {
        formData.append(
          "date_of_filling_lawsuit",
          this.changeformatDatetoinsert(
            this.showaddItem.date_of_filling_lawsuit
          )
        );
      }
      formData.append("remark", this.showaddItem.remark.trim());
      formData.append("page_no", this.showaddItem.page_no.trim());
      if (
        this.showaddItem.date_of_renewal !== "" &&
        this.showaddItem.date_of_renewal !== null
      ) {
        formData.append(
          "date_of_renewal",
          this.changeformatDatetoinsert(this.showaddItem.date_of_renewal)
        );
      }

      formData.append(
        "condition_of_regis",
        this.showaddItem.condition_of_regis.trim()
      );
      if (
        this.showaddItem.date_of_opposition !== "" &&
        this.showaddItem.date_of_opposition !== null
      ) {
        formData.append(
          "date_of_opposition",
          this.changeformatDatetoinsert(this.showaddItem.date_of_opposition)
        );
      }
      if (
        this.showaddItem.date_of_renewal_filed !== "" &&
        this.showaddItem.date_of_renewal_filed !== null
      ) {
        formData.append(
          "date_of_renewal_filed",
          this.changeformatDatetoinsert(this.showaddItem.date_of_renewal_filed)
        );
      }
      if (
        this.showaddItem.next_deadline !== "" &&
        this.showaddItem.next_deadline !== null
      ) {
        formData.append(
          "next_deadline",
          this.changeformatDatetoinsert(this.showaddItem.next_deadline)
        );
      }
      if (
        this.showaddItem.dateof_filling_affidavits !== "" &&
        this.showaddItem.dateof_filling_affidavits !== null
      ) {
        formData.append(
          "dateof_filling_affidavits",
          this.changeformatDatetoinsert(
            this.showaddItem.dateof_filling_affidavits
          )
        );
      }
      formData.append("tmstatusasoff", this.showaddItem.tmstatusasoff);
      formData.append("dip_link", this.showaddItem.dip_link.trim());
      formData.append(
        "user_create",
        Number(localStorage.getItem(server.USER_ID))
      );
      formData.append("closed", this.showaddItem.closed);
      if (
        this.showaddItem.date_of_closed !== "" &&
        this.showaddItem.date_of_closed !== null
      ) {
        formData.append(
          "date_of_closed",
          this.changeformatDatetoinsert(this.showaddItem.date_of_closed)
        );
      }
      if (
        this.showaddItem.date_of_issuing_certificate !== "" &&
        this.showaddItem.date_of_issuing_certificate !== null
      ) {
        formData.append(
          "date_of_issuing_certificate",
          this.changeformatDatetoinsert(
            this.showaddItem.date_of_issuing_certificate
          )
        );
      }
      formData.append("disclaim", this.showaddItem.disclaim);

      const resultMasterTM = await api.createMasterTMV2(formData);

      if (resultMasterTM.status == 200 || resultMasterTM.status == 201) {
        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Create",
          table_name: "mastertm",
          table_id: resultMasterTM.data.mastertm_id,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.addTransectionLogCoreApi(dataAdd);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog
        );

        this.$hideLoader();
        this.dialogAddmastertm = false;
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "save data",
          "save data success",
          "text-h5 green--text text-center",
          `/appointmenttm-add/${resultMasterTM.data.file_no}/${this.date_of_renewal}`
        );
        return;
      } else if (resultMasterTM.status == 204) {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "data duplicate ",
          "please check File No. and Application No.",
          "text-h5 red--text text-center"
        );
        return;
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "save data",
          "can't save data",
          "text-h5 red--text text-center"
        );
        return;
      }
    },

    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(1);
      this.objecttype_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
      // const result = await api.getAllMasterTM();
      // this.mDataArray = result.data;
    },
    async loaddatacountry() {
      const result = await api.getAllCountry();
      console.log("result.data")
      console.log(result.data)
      this.country_list = result.data;
    },
    async loaddatatmupdatestatus() {
      const result = await api.getAlltmupdatestatus();
      this.tmstatus_list = result.data;
    },

    async onSelectOwnerChange() {
      if (this.owner_contact_list.length > 0) {
        for (const [index, item] of this.owner_contact_list.entries()) {
          item.owner_address =
            item.address + " " + item.city + " " + item.country;
        }
      }
    },
    async onSelectCountryChange(name) { },
    async onSelectAgentChange(id) {
      let setdata;
      setdata = this.contact_agent_list.filter((item) => {
        if (item.contact_id == id) {
          this.showaddItem.agent_email = item.email;
          this.showaddItem.agent_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    async onSelectAssociateChange(id) {
      let setdata;
      setdata = this.contact_associate_list.filter((item) => {
        if (item.contact_id == id) {
          this.showaddItem.associate_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    async onSelectObjiTypeChange(objecttype_id) {
      if (objecttype_id == 0) return;
      const selectedItem = this.objecttype_list.find(
        (item) => item.objecttype_id === objecttype_id
      );

      this.setDefluatData();

      this.showFiling = false;
      this.showIsSearch = false;
      this.showTrademarkOhter = false;
      this.showTrademarkInfringementPoliceCustoms = false;

      this.showaddItem.file_no = "";

      if (objecttype_id == 1 || objecttype_id == 3) {
        this.showFiling = true;
      } else {
        var objecttype_name = selectedItem.objecttype_code;

        if (objecttype_id == 6 || objecttype_id == 10) {
          if (objecttype_id == 10) {
            this.labels = [
              "อัปโหลดไฟล์คำวินิจฉัยของนายทะเบียน",
              "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
              "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
            ];
            this.labelsDecripnt = [
              "วันที่รับคำวินิจฉัยของนายทะเบียน",
              "วันที่รับคำวินิจฉัยของชั้นคณะกรรมการ",
              "วันที่รับคำวินิจฉัยไปศาล",
            ];
          }
          this.showIsSearch = true;
        } else if (objecttype_id == 7 || objecttype_id == 11) {
          // this.showTrademarkOhter = true;
          this.labels = [
            "อัปโหลดไฟล์คำวินิจฉัยของนายทะเบียน",
            "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
            "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
          ];
          this.labelsDecripnt = [
            "วันที่รับคำวินิจฉัยของนายทะเบียน",
            "วันที่รับคำวินิจฉัยของชั้นคณะกรรมการ",
            "วันที่รับคำวินิจฉัยไปศาล",
          ];
        } else if (objecttype_id == 8) {
          this.labels = [
            "อัปโหลดไฟล์คำวินิจฉัยของชั้นคณะกรรมการ",
            "อัปโหลดไฟล์คำวินิจฉัยไปศาล",
          ];
          this.labelsDecripnt = [
            "วันที่รับคำวินิจฉัยของชั้นคณะกรรมการ",
            "วันที่รับคำวินิจฉัยไปศาล",
          ];
        } else if (objecttype_id == 9) {
          this.showTrademarkInfringementPoliceCustoms = true;
          // objecttype_name = "Trademark Infringement Police Customs";
        }

        const res_mode = await api.fineDocRunningByModlue(
          objecttype_name,
          Number(localStorage.getItem(server.COMPANYID))
        );

        if (res_mode.status == 200 && res_mode.data) {
          const { id_prefix, running_year, running_next, running_len } =
            res_mode.data;
          const runningStr = String(running_next).padStart(running_len, "0");
          const docrunning = `${id_prefix}${running_year}${runningStr}`;
          this.showaddItem.file_no = docrunning;
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "No data File No. Please contact the system administrator.",
            "text-h5 red--text text-center"
          );
          return;
        }
      }
    },
    async onSelectCustomerChange() { },

    async popupdeletefile(index) {
      this.fileindex = index;
      this.dialogDelete = true;
    },
    async popupdeletefile_cer(index_cer) {
      this.fileindex_cer = index_cer;
      this.dialogDelete_cer = true;
    },
    async closeDelete() {
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async closeDelete_cer() {
      this.fileindex = -1;
      this.dialogDelete_cer = false;
    },
    async deleteItemConfirm() {
      this.preview_list2 = [];
      this.getpreview_list.splice(this.fileindex, 1);
      this.image_list.splice(this.fileindex, 1);
      await this.getPdfforAdd(this.getpreview_list);

      this.filename.splice(this.fileindex, 1);
      this.preview_list2 = this.preview_list;
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm_cer() {
      this.preview_list2_cer = [];
      this.getpreview_list_cer.splice(this.fileindex_cer, 1);
      this.image_list_cer.splice(this.fileindex_cer, 1);
      await this.getPdfforAdd_cer(this.getpreview_list_cer);

      this.filename_cer.splice(this.fileindex_cer, 1); // เปลี่ยนเป็น _cer
      this.preview_list2_cer = this.preview_list_cer;
      this.fileindex_cer = -1;
      this.dialogDelete_cer = false;
    },
    async popupdeleteimage(index) {
      this.indexDelImage = index;
      this.dialogDeleteimage = true;
    },
    async popupdeleteimageOpposed(index) {
      this.indexDelImageOpposed = index;
      this.dialogDeleteimageOpposed = true;
    },
    async closeDeleteimage() {
      this.dialogDeleteimage = false;
    },
    async closeDeleteimageOpposed() {
      this.dialogDeleteimageOpposed = false;
    },
    async deleteItemConfirmimage() {
      this.images.splice(this.indexDelImage, 1);
      this.imagenames.splice(this.indexDelImage, 1);
      this.previews.splice(this.indexDelImage, 1);

      if (this.imagenames.length === 0) {
        this.checkimageadd = false;
      }
      this.dialogDeleteimage = false;
    },
    async deleteItemConfirmimageOpposed() {
      this.imagesOpposed.splice(this.indexDelImageOpposed, 1);
      this.imagenamesOpposed.splice(this.indexDelImageOpposed, 1);
      this.previewsOpposed.splice(this.indexDelImageOpposed, 1);
      this.dialogDeleteimageOpposed = false;
    },
    async popuppreviewfile(fileindex) {
      let pdf_newTab = window.open("");
      pdf_newTab.document.write(
        "<html><head><title>PDF File</title></head><body><iframe title='MY title' width='100%' height='100%' src='" +
        this.getpreview_list[fileindex] +
        "'></iframe></body></html>"
      );

      return;
    },
    async popuppreviewfile_cer(fileindex_cer) {
      let pdf_newTab_cer = window.open("");
      pdf_newTab_cer.document.write(
        "<html><head><title>PDF File</title></head><body><iframe title='MY title' width='100%' height='100%' src='" +
        this.getpreview_list_cer[fileindex_cer] +
        "'></iframe></body></html>"
      );

      return;
    },
    async closepreviewfile() {
      this.dialogpreviewfile = false;
    },
    popuppreviewimage(index) {
      const imageTab = window.open("");
      imageTab.document.write(`
    <html>
      <head>
        <title>Preview Image</title>
        <style>
          body {
            margin: 0;
            background-color: #000;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }
          .toolbar {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 50px;
            background: rgba(20, 20, 20, 0.9);
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
            z-index: 10;
            backdrop-filter: blur(6px); /* เบลอพื้นหลัง */
          }
          .icon-btn {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: rgba(255,255,255,0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
          }
          .icon-btn:hover {
            background: rgba(255,255,255,0.25);
            transform: scale(1.1);
          }
          .icon-btn svg {
            width: 22px;
            height: 22px;
            fill: #fff;
          }
          img {
            max-width: 100%;
            max-height: 100%;
          }
        </style>
      </head>
      <body>
        <div class="toolbar">
          <a href="${this.previews[index]}" download="image_${index}.jpg" class="icon-btn" title="ดาวน์โหลด">
            <!-- SVG ไอคอนดาวน์โหลด -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M5 20h14v-2H5v2zm7-18v12l4-4h-3V4h-2v6H8l4 4z"/>
            </svg>
          </a>
        </div>
        <img src="${this.previews[index]}" alt="Preview" />
      </body>
    </html>
  `);
      return;
    },
    popuppreviewimageOpposed(index) {
      const imageTab = window.open("");
      imageTab.document.write(`
    <html>
      <head>
        <title>Preview Image</title>
        <style>
          body {
            margin: 0;
            background-color: #000;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }
          .toolbar {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 50px;
            background: rgba(20, 20, 20, 0.9);
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
            z-index: 10;
            backdrop-filter: blur(6px);
          }
          .icon-btn {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: rgba(255,255,255,0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s ease;
          }
          .icon-btn:hover {
            background: rgba(255,255,255,0.25);
            transform: scale(1.1);
          }
          .icon-btn svg {
            width: 22px;
            height: 22px;
            fill: #fff;
          }
          img {
            max-width: 100%;
            max-height: 100%;
          }
        </style>
      </head>
      <body>
        <div class="toolbar">
          <a href="${this.previewsOpposed[index]}" 
             download="${this.imagenamesOpposed[index] || "image_" + index
        }.jpg" 
             class="icon-btn" 
             title="ดาวน์โหลด">
            <!-- SVG ไอคอนดาวน์โหลด -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M5 20h14v-2H5v2zm7-18v12l4-4h-3V4h-2v6H8l4 4z"/>
            </svg>
          </a>
        </div>
        <img src="${this.previewsOpposed[index]}" alt="Preview" />
      </body>
    </html>
  `);
      return;
    },
    async closepreviewimage() {
      this.dialogpreviewimage = false;
    },
    // getUniqueFileNameImage(fileName, existingNames = []) {
    //   // แปลงชื่อไฟล์ให้ปลอดภัย
    //   let baseName = fileName.replace(/[^a-zA-Z0-9._\-ก-๙]/g, "_");
    //   let finalName = baseName;
    //   let counter = 1;

    //   while (existingNames.includes(finalName)) {
    //     const dotIndex = baseName.lastIndexOf(".");
    //     if (dotIndex !== -1) {
    //       const name = baseName.substring(0, dotIndex);
    //       const ext = baseName.substring(dotIndex);
    //       finalName = `${name}-${counter}${ext}`;
    //     } else {
    //       finalName = `${baseName}-${counter}`;
    //     }
    //     counter++;
    //   }

    //   return finalName;
    // },

    // // ฟังก์ชันอัปโหลดและ resize รูป
    // previewImage(event) {
    //   const files = event.target.files;
    //   if (!files.length) return;

    //   for (let i = 0; i < files.length; i++) {
    //     const file = files[i];

    //     if (!file.type.startsWith("image/")) {
    //       alert("กรุณาเลือกไฟล์รูปภาพเท่านั้น");
    //       continue;
    //     }

    //     // ใช้ฟังก์ชันตรวจสอบชื่อไฟล์ซ้ำ
    //     const safeName = this.getUniqueFileNameImage(
    //       file.name,
    //       this.imagenames
    //     );

    //     // เก็บไฟล์
    //     this.images.push(file);
    //     this.imagenames.push(safeName);

    //     // อ่านไฟล์แล้ว resize
    //     const reader = new FileReader();
    //     reader.onload = (e) => {
    //       const img = new Image();
    //       img.onload = () => {
    //         const canvas = document.createElement("canvas");
    //         const ctx = canvas.getContext("2d");

    //         const maxSize = 592;
    //         let width = img.width;
    //         let height = img.height;

    //         // คำนวณอัตราส่วน
    //         if (width > height) {
    //           if (width > maxSize) {
    //             height = Math.round((height * maxSize) / width);
    //             width = maxSize;
    //           }
    //         } else {
    //           if (height > maxSize) {
    //             width = Math.round((width * maxSize) / height);
    //             height = maxSize;
    //           }
    //         }

    //         canvas.width = width;
    //         canvas.height = height;

    //         ctx.drawImage(img, 0, 0, width, height);

    //         const resizedDataUrl = canvas.toDataURL("image/jpeg", 0.9);
    //         this.previews.push(resizedDataUrl);
    //       };
    //       img.src = e.target.result;
    //     };
    //     reader.readAsDataURL(file);
    //   }

    //   this.checkimageadd = true;

    //   // รีเซต input เพื่อให้เลือกไฟล์ชื่อเดิมอีกครั้งได้
    //   event.target.value = null;
    // },
    // generateUniqueFileName(originalName) {
    //   // sanitize ก่อน (แทนทุกตัวที่ไม่ใช่ a-z, A-Z, 0-9, ., _, -, ก-๙ → _)
    //   let sanitizedName = originalName.replace(/[^a-zA-Z0-9._\-ก-๙]/g, "_");

    //   let newName = sanitizedName;
    //   let nameIndex = 1;
    //   const allNames = [...this.filename, ...this.filename_cer]; // เช็ครวมกันทั้ง main และ cer

    //   while (allNames.includes(newName)) {
    //     const dotIndex = sanitizedName.lastIndexOf(".");
    //     if (dotIndex !== -1) {
    //       // ถ้ามี .นามสกุลไฟล์ → แทรก -1, -2, ...
    //       newName = `${sanitizedName.substring(
    //         0,
    //         dotIndex
    //       )}-${nameIndex}${sanitizedName.substring(dotIndex)}`;
    //     } else {
    //       // ถ้าไม่มีนามสกุล
    //       newName = `${sanitizedName}-${nameIndex}`;
    //     }
    //     nameIndex++;
    //   }

    //   return newName;
    // },

    // async previewMultiImage(event) {
    //   const input = event.target;
    //   if (!input.files) return;

    //   for (let i = 0; i < input.files.length; i++) {
    //     const originalFile = input.files[i];
    //     if (originalFile.type !== "application/pdf") continue;

    //     // สร้างชื่อไฟล์ไม่ซ้ำ
    //     const newName = this.generateUniqueFileName(originalFile.name);

    //     // Clone ไฟล์พร้อมชื่อใหม่
    //     const renamedFile = new File([originalFile], newName, {
    //       type: originalFile.type,
    //     });
    //     this.image_list.push(renamedFile);
    //     this.filename.push(newName);

    //     // อ่าน preview
    //     const result = await new Promise((resolve) => {
    //       const reader = new FileReader();
    //       reader.onload = (e) => resolve(e.target.result);
    //       reader.readAsDataURL(renamedFile);
    //     });

    //     this.getpreview_list.push(result);
    //     this.preview_list.push(result);
    //   }

    //   this.preview_list2 = this.preview_list;
    //   this.checkfileeadd = true;
    //   event.target.value = null;
    // },
    // async previewMultiImage_cer(event) {
    //   const input_cer = event.target;
    //   if (!input_cer.files) return;

    //   for (let i = 0; i < input_cer.files.length; i++) {
    //     const originalFile_cer = input_cer.files[i];
    //     if (originalFile_cer.type !== "application/pdf") continue;

    //     const newName_cer = this.generateUniqueFileName(originalFile_cer.name);

    //     const renamedFile_cer = new File([originalFile_cer], newName_cer, {
    //       type: originalFile_cer.type,
    //     });
    //     this.image_list_cer.push(renamedFile_cer);
    //     this.filename_cer.push(newName_cer);

    //     const result = await new Promise((resolve) => {
    //       const reader = new FileReader();
    //       reader.onload = (e) => resolve(e.target.result);
    //       reader.readAsDataURL(renamedFile_cer);
    //     });

    //     this.getpreview_list_cer.push(result);
    //     this.preview_list_cer.push(result);
    //   }

    //   this.preview_list2_cer = this.preview_list_cer;
    //   this.checkfileeadd_cer = true;
    //   event.target.value = null;
    // },
    // reset: function () {
    //   this.image = null;
    //   this.previewimage = null;
    //   this.image_list = [];
    //   this.preview_list = [];
    // },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = [];
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },
    async getPdfforAdd(item) {
      this.preview_list = [];
      let getfile = [];
      getfile = item;
      getfile.forEach((file, index) => {
        this.preview_list.push(pdfvuer.createLoadingTask(`${file}`));
      });
      this.preview_list.forEach((item, index) => {
        item.then((pdf) => {
          this.numPages = pdf.numPages;
          // window.onscroll = function() {
          //   changePage();
          //   stickyNav();
          // };
          // Get the offset position of the navbar
          // var sticky = $("#buttons")[0].offsetTop;
          // // Add the sticky class to the this.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
          // function stickyNav() {
          //   if (window.pageYOffset >= sticky) {
          //     $("#buttons")[0].classList.remove("hidden");
          //   } else {
          //     $("#buttons")[0].classList.add("hidden");
          //   }
          // }
          function changePage() {
            var i = 1,
              count = Number(pdf.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i + 1))
              ) {
                this.page = i;
              }
              i++;
            } while (i < count);
            if (
              window.pageYOffset >= this.findPos(document.getElementById(i))
            ) {
              this.page = i;
            }
          }
        });
      });
      this.checkfileadd = true;
    },
    async getPdfforAdd_cer(item_cer) {
      this.preview_list_cer = [];
      let getfile_cer = [];
      getfile_cer = item_cer;

      getfile_cer.forEach((file_cer, index_cer) => {
        this.preview_list_cer.push(pdfvuer.createLoadingTask(`${file_cer}`));
      });

      this.preview_list_cer.forEach((item_cer, index_cer) => {
        item_cer.then((pdf_cer) => {
          this.numPages_cer = pdf_cer.numPages;

          function changePage_cer() {
            var i_cer = 1,
              count_cer = Number(pdf_cer.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i_cer)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i_cer + 1))
              ) {
                this.page_cer = i_cer;
              }
              i_cer++;
            } while (i_cer < count_cer);

            if (
              window.pageYOffset >= this.findPos(document.getElementById(i_cer))
            ) {
              this.page_cer = i_cer;
            }
          }
        });
      });

      this.checkfileadd_cer = true;
    },
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    findPos(obj) {
      return obj.offsetTop;
    },
    async CalculateNewRenewalDate() {
      let addyear = 10;
      let addday = 1;

      if (
        this.showaddItem.date_of_renewal &&
        this.showaddItem.date_of_renewal != ""
      ) {
        addday = 0;
        this.date_of_renewal = new Date(
          new Date(this.date_of_renewal).setFullYear(
            new Date(this.date_of_renewal).getFullYear() + addyear,
            new Date(this.date_of_renewal).getMonth(),
            new Date(this.date_of_renewal).getDate() - addday
          ) -
          new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10);
        this.showaddItem.date_of_renewal = this.formatDate(
          this.date_of_renewal
        );
        this.disableCalculateNewRenewalDate = true;
      } else {
        if (
          !this.showaddItem.date_of_application ||
          this.showaddItem.date_of_application == ""
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please enter Application Date Data",
            "text-h5 red--text text-center"
          );
          return;
        }
        this.date_of_renewal = new Date(
          new Date(this.date_of_application).setFullYear(
            new Date(this.date_of_application).getFullYear() + addyear,
            new Date(this.date_of_application).getMonth(),
            new Date(this.date_of_application).getDate() - addday
          ) -
          new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10);
        this.showaddItem.date_of_renewal = this.formatDate(
          this.date_of_renewal
        );
        this.disableCalculateNewRenewalDate = true;
      }
    },
    async Selectchangedate_of_application() {
      // this.disableCalculateNewRenewalDate = false;
    },

    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    // formatDate(date) {
    //   if (!date) return null;

    //   const [year, month, day] = date.split("-");
    //   return `${year}/${month}/${day}`;
    // },
    // parseDate(date) {
    //   if (!date) return null;

    //   const [year, month, day] = date.split("/");
    //   return `${year}/${month.padStart(2, "0")}/${day.padStart(2, "0")}`;
    // },
    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    async previewnoticefilepdf(index) {
      var checkfile = this.image_listnotice[index];

      if (checkfile.type === "application/pdf") {
        // ---- PDF Preview ----
        const reader = new FileReader();
        reader.onload = (e) => {
          const checkfile = e.target.result;
          let pdf_newTab = window.open("");
          pdf_newTab.document.write(`
        <html>
          <head>
            <title>PDF Preview</title>
            <style>
              html, body {
                margin: 0;
                height: 100%;
                overflow: hidden;
              }
              iframe {
                border: none;
                width: 100%;
                height: 100%;
              }
            </style>
          </head>
          <body>
            <iframe src="${checkfile}" title="PDF Preview"></iframe>
          </body>
        </html>
      `);
          pdf_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      } else if (
        checkfile.type === "application/msword" ||
        checkfile.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        // ---- Word File → Force Download ----
        const url = URL.createObjectURL(checkfile);
        const link = document.createElement("a");
        link.href = url;
        link.download = checkfile.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } else {
        // ---- Image Preview ----
        const reader = new FileReader();
        reader.onload = (e) => {
          const checkfile = e.target.result; // Base64 image data
          let image_newTab = window.open(""); // เปิดแท็บใหม่
          image_newTab.document.write(`
        <html>
          <head>
            <title>Image Preview</title>
            <style>
              html, body {
                margin: 50px 0 0 0;
                height: 80%;
                overflow: hidden;
                background-color: black;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            </style>
          </head>
          <body>
            <img src="${checkfile}" title="Image Preview" />
          </body>
        </html>
      `);
          image_newTab.document.close();
        };
        reader.readAsDataURL(checkfile);
      }
    },
    async previewattachfile(index) {
      const fileName = this.filenameattach[index].toLowerCase();
      const fileData = this.getpreview_listattach[index];

      // ---- PDF ----
      if (fileName.endsWith(".pdf")) {
        let pdf_newTab = window.open("");
        pdf_newTab.document.write(`
      <html>
        <head>
          <title>PDF Preview</title>
          <style>
            html, body {
              margin: 0;
              height: 100%;
              overflow: hidden;
            }
            iframe {
              border: none;
              width: 100%;
              height: 100%;
            }
          </style>
        </head>
        <body>
          <iframe src="${fileData}" title="PDF Preview"></iframe>
        </body>
      </html>
    `);
        return;
      }
      // ---- Word ----
      else if (fileName.endsWith(".doc") || fileName.endsWith(".docx")) {
        // ดาวน์โหลดไฟล์แทน
        const blob = this.image_listattach[index]; // File object
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = blob.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        return;
      }
      // ---- Image ----
      else {
        this.previewattachimage = fileData;
        const imageTab = window.open("");
        imageTab.document.write(`
      <html>
        <head>
          <title>Preview Image</title>
        </head>
        <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
          <img src="${this.previewattachimage}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
        </body>
      </html>
    `);
        return;
      }
    },
    async confirmdeletenoticefile(index) {
      this.indexdeleteattachfilelist = index;
      this.dialogconfirmdeletenoticefile = true;
    },
    async closedialogconfirmdeletenoticefile() {
      this.dialogconfirmdeletenoticefile = false;
    },
    async deletedialogconfirmdeletenoticefile() {
      this.getpreview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.preview_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.image_listnotice.splice(this.indexdeleteattachfilelist, 1);
      this.filenamenotice.splice(this.indexdeleteattachfilelist, 1);
      this.dialogconfirmdeletenoticefile = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    sanitizeFileName(fileName) {
      const dotIndex = fileName.lastIndexOf(".");
      const baseName =
        dotIndex !== -1 ? fileName.substring(0, dotIndex) : fileName;
      const extension = dotIndex !== -1 ? fileName.substring(dotIndex) : "";

      const sanitizedBase = baseName.replace(/[^a-zA-Z0-9-_ก-ฮะ-์]/g, "_");
      return sanitizedBase + extension;
    },

    // --- ฟังก์ชันตรวจสอบชื่อซ้ำและต่อเลข ---
    getUniqueFileName(file) {
      let name = this.sanitizeFileName(file.name);
      let base = name;
      let counter = 1;

      while (this.dataFileAll.includes(name)) {
        const dotIndex = base.lastIndexOf(".");
        const baseName = dotIndex !== -1 ? base.substring(0, dotIndex) : base;
        const ext = dotIndex !== -1 ? base.substring(dotIndex) : "";
        name = `${baseName}-${counter}${ext}`;
        counter++;
      }

      this.dataFileAll.push(name);
      const newFile = new File([file], name, { type: file.type });
      return newFile;
    },
    // --- ฟังก์ชัน preview notice ---
    async previewMultiFile(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        const file = this.getUniqueFileName(rawFile);

        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        this.getpreview_listnotice.push(result);
        this.preview_listnotice.push(result);

        // ✅ รองรับ pdf, image, และ word
        if (
          file.type === "application/pdf" ||
          file.type.split("/")[0] === "image" ||
          file.type === "application/msword" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          this.image_listnotice.push(file);
          this.filenamenotice.push(file.name);
        }
      }

      this.preview_listnotice2 = this.preview_listnotice;
      this.checkfilenotice = true;
      input.value = "";
    },
    previewImage(event) {
      const files = event.target.files;
      if (!files.length) return;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file.type.startsWith("image/")) {
          alert("กรุณาเลือกไฟล์รูปภาพเท่านั้น");
          continue;
        }

        // ✅ ใช้ getUniqueFileName(file) แทน
        const uniqueFile = this.getUniqueFileName(file);

        // เก็บไฟล์ (เก็บไฟล์ใหม่ที่ชื่อ unique แล้ว)
        this.images.push(uniqueFile);
        this.imagenames.push(uniqueFile.name);

        // อ่านไฟล์แล้ว resize
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const maxSize = 592;
            let width = img.width;
            let height = img.height;

            // คำนวณอัตราส่วน
            if (width > height) {
              if (width > maxSize) {
                height = Math.round((height * maxSize) / width);
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width = Math.round((width * maxSize) / height);
                height = maxSize;
              }
            }

            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(img, 0, 0, width, height);

            const resizedDataUrl = canvas.toDataURL("image/jpeg", 0.9);
            this.previews.push(resizedDataUrl);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      this.checkimageadd = true;

      // รีเซต input เพื่อให้เลือกไฟล์ชื่อเดิมอีกครั้งได้
      event.target.value = null;
    },
    previewImageOpposed(event) {
      const files = event.target.files;
      if (!files.length) return;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file.type.startsWith("image/")) {
          alert("กรุณาเลือกไฟล์รูปภาพเท่านั้น");
          continue;
        }

        // ✅ ใช้ getUniqueFileName(file) แทน
        const uniqueFile = this.getUniqueFileName(file);

        // เก็บไฟล์ Opposed
        this.imagesOpposed.push(uniqueFile);
        this.imagenamesOpposed.push(uniqueFile.name);

        // อ่านไฟล์แล้ว resize
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const maxSize = 592;
            let width = img.width;
            let height = img.height;

            // คำนวณอัตราส่วน
            if (width > height) {
              if (width > maxSize) {
                height = Math.round((height * maxSize) / width);
                width = maxSize;
              }
            } else {
              if (height > maxSize) {
                width = Math.round((width * maxSize) / height);
                height = maxSize;
              }
            }

            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(img, 0, 0, width, height);

            const resizedDataUrl = canvas.toDataURL("image/jpeg", 0.9);
            this.previewsOpposed.push(resizedDataUrl);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      this.checkimageaddOpposed = true;

      // รีเซต input เพื่อให้เลือกไฟล์ชื่อเดิมอีกครั้งได้
      event.target.value = null;
    },

    async previewMultiAttachFile(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        const file = this.getUniqueFileName(rawFile);

        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        this.getpreview_listattach.push(result);
        this.preview_listattach.push(result);

        // ✅ รองรับ PDF, Image และ Word
        if (
          file.type === "application/pdf" ||
          file.type.split("/")[0] === "image" ||
          file.type === "application/msword" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          this.image_listattach.push(file);
          this.filenameattach.push(file.name);
        }
      }

      this.preview_listattach2 = this.preview_listattach;
      this.checkfileattach = true;
      input.value = "";
    },
    onFilesSelected(index, event) {
      const input = event.target;
      if (!input || !input.files || input.files.length === 0) return;

      const rawFiles = Array.from(input.files);

      // ให้แน่ใจว่า decisionBoxes[index].files และ .previews มีอยู่ (reactive)
      if (!this.decisionBoxes[index]) {
        console.warn("no decisionBoxes entry for index", index);
        return;
      }
      if (!this.decisionBoxes[index].files) {
        this.$set(this.decisionBoxes[index], "files", []);
      }
      if (!this.decisionBoxes[index].previews) {
        this.$set(this.decisionBoxes[index], "previews", []);
      }

      for (const rawFile of rawFiles) {
        // เฉพาะ PDF เท่านั้น (เช็กทั้ง mime type และนามสกุล)
        const isPdf =
          rawFile.type === "application/pdf" ||
          rawFile.name.toLowerCase().endsWith(".pdf");
        if (!isPdf) {
          console.warn("skip non-pdf file:", rawFile.name);
          continue;
        }

        // ใช้ฟังก์ชันของคุณในการ sanitize + กันชื่อซ้ำ
        // getUniqueFileName(file) ตามที่คุณมี จะคืนเป็น File ใหม่ และ push ชื่อเข้า this.dataFileAll
        const file =
          typeof this.getUniqueFileName === "function"
            ? this.getUniqueFileName(rawFile)
            : new File([rawFile], rawFile.name, { type: rawFile.type }); // fallback

        // เก็บไฟล์ลงใน box
        this.decisionBoxes[index].files.push(file);

        // สร้าง preview (ถ้าต้องการแสดง thumbnail / viewer)
        const reader = new FileReader();
        reader.onload = (e) => {
          this.decisionBoxes[index].previews.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }

      // รีเซ็ต input เพื่อเปิดให้เลือกไฟล์เดิมได้อีกครั้ง
      input.value = "";
    },
    async previewMultiImage(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        // ✅ รับเฉพาะไฟล์ PDF เท่านั้น
        if (rawFile.type !== "application/pdf") continue;

        // ✅ สร้างชื่อไฟล์ไม่ซ้ำ
        const file = this.getUniqueFileName(rawFile);

        // ✅ อ่านไฟล์เป็น Base64
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        // ✅ push preview
        this.getpreview_list.push(result);
        this.preview_list.push(result);

        // ✅ push file และชื่อไฟล์
        this.image_list.push(file);
        this.filename.push(file.name);
      }

      // ✅ อัปเดตตัวแปร preview อื่น ๆ
      this.preview_list2 = this.preview_list;
      this.checkfileeadd = true;

      // ✅ reset input
      input.value = "";
    },
    async previewMultiImage_cer(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        // ✅ รับเฉพาะไฟล์ PDF เท่านั้น
        if (rawFile.type !== "application/pdf") continue;

        // ✅ สร้างชื่อไฟล์ไม่ซ้ำ
        const file = this.getUniqueFileName(rawFile);

        // ✅ อ่านไฟล์เป็น Base64 สำหรับ preview
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        // ✅ เก็บ preview
        this.getpreview_list_cer.push(result);
        this.preview_list_cer.push(result);

        // ✅ เก็บไฟล์และชื่อไฟล์
        this.image_list_cer.push(file);
        this.filename_cer.push(file.name);
      }

      // ✅ อัปเดตรายการ preview สำรอง
      this.preview_list2_cer = this.preview_list_cer;
      this.checkfileeadd_cer = true;

      // ✅ reset input
      input.value = "";
    },
    async uploadCSVFile(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      const newFiles = [];

      for (let rawFile of files) {
        if (!rawFile.name.toLowerCase().endsWith(".csv")) continue;

        const file = this.getUniqueFileName
          ? this.getUniqueFileName(rawFile)
          : rawFile;
        newFiles.push(file);
      }

      // แทนที่ไฟล์เก่าด้วยไฟล์ใหม่ทั้งหมด
      this.fileList_good_service = newFiles;

      // reset input เพื่อให้เลือกไฟล์ซ้ำได้
      input.value = "";
    },
    removeFileGood(type, index) {
      let list;
      if (type === "good_service") list = this.fileList_good_service;
      list.splice(index, 1);
    },
    // --- ฟังก์ชัน preview receipt ---
    async previewMultiReceipt(event) {
      const input = event.target;
      if (!input.files || !input.files.length) return;

      const files = Array.from(input.files);
      for (let rawFile of files) {
        const file = this.getUniqueFileName(rawFile);

        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });

        this.getpreview_listreceipt.push(result);
        this.preview_listrecicpt.push(result);

        if (
          file.type === "application/pdf" ||
          file.type.split("/")[0] === "image"
        ) {
          this.image_listrecicpt.push(file);
          this.filenamerecive.push(file.name);
        }
      }

      this.preview_listrecipt2 = this.preview_listrecicpt;
      this.checkfileattach = true;
      input.value = "";
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.widthbtnnoticefile {
  width: 100%;
}

.widthbtncal {
  width: 100%;
}

.widthbtnimagefile {
  width: 40%;
}

.widthsizesearch {
  width: 70%;
}

.v-btn:not(.v-btn--round).v-size--default.buttongold {
  background-color: #464231;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 0.875rem;
}

.file-link {
  cursor: pointer;
  color: blue;
  /* ค่า default */
  transition: color 0.2s ease;
}

.file-link:hover {
  color: gray;
}

.word-file {
  color: green !important;
  /* ถ้าเป็น Word → สีเขียว */
}

.word-file:hover {
  color: darkgreen !important;
  /* hover สำหรับ Word */
}

.vali {
  color: red;
}

.mt-hf {
  margin-top: -20px;
}

.mt-h {
  margin-top: -20px;
}

.text-field-style {
  margin-top: -15px;
  margin-bottom: 22px;
  padding: 6px 10px;
  background-color: #f5f5f5;
  border: 1px solid #9e9e9e;
  border-radius: 4px;
  font-size: 14px;
  color: #a19898;
  min-height: 96px;
}

.scrollable-card {
  max-height: 185px;
  overflow-y: auto;
  overflow-x: hidden;
}

.bt-add {
  color: #1d88ac;
}

.bt-del {
  color: red;
}

.image-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.filename-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 14px;
  padding: 4px;
  text-align: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(227, 244, 253, 0.8);
}

.preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: fill;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.image-wrapper-carousel {
  position: relative;
  width: 100%;
  /* ใช้ความกว้างเป็นหลัก */
  height: 240px;
  /* ความสูงคงที่ */
  display: flex;
  justify-content: center;
  /* จัดกลางแนวนอน */
  align-items: center;
  /* จัดกลางแนวตั้ง */
  overflow: hidden;
  /* ซ่อนส่วนเกินของรูป */
  border-radius: 8px;
  background-color: #f5f5f5;
  /* สีพื้นหลังถ้ารูปเล็ก */
}

/* รูป */
.preview-img-carousel {
  width: 100%;
  /* ความกว้างเต็ม wrapper */
  height: auto;
  /* ความสูงปรับตามอัตราส่วน */
  max-height: 100%;
  /* ไม่เกินความสูง wrapper */
  object-fit: contain;
  /* ยังคงอัตราส่วน */
  cursor: pointer;
}

/* ปุ่มลบอยู่มุมบนซ้าย */
.delete-btn-carousel {
  position: absolute;
  top: 5px;
  right: 5px;
  /* ปรับจาก left -> right */
  background: rgba(227, 244, 253, 0.8);
  z-index: 10;
}

/* ชื่อไฟล์ overlay ติดขอบล่าง */
.filename-overlay-carousel {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 4px 8px;
  font-size: 14px;
  text-align: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  z-index: 5;
}

/* ตัวเลขนับรูป */
.counter-overlay {
  position: absolute;
  top: 5px;
  /* อยู่ด้านบน */
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 10;
}

/* carousel มีเงา */
.carousel-with-shadow {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;
  max-width: 240px;
}

.no-image-placeholder {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 240px;
  /* ให้เท่ากับ carousel */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden;
  max-width: 240px !important;
}

.pdf-link {
  color: #1e88e5;
  /* PDF สีฟ้า */
  text-decoration: none;
  /* ลบเส้นใต้ */
  cursor: pointer;
}

.pdf-link:hover {
  color: #64b5f6;
  /* สีฟ้อ่อนเมื่อ hover */
}

.word-link {
  color: #43a047;
  /* Word สีเขียว */
  text-decoration: none;
  cursor: pointer;
}

.word-link:hover {
  color: #81c784;
  /* hover สีเขียวอ่อน */
}

.custom-radio-label .v-label {
  font-size: 16px;
  /* ปรับตามขนาดที่ต้องการ */
  font-weight: bold;
}

.small-radio .v-input--selection-controls__ripple,
.small-radio .v-input--selection-controls__input {
  width: 16px;
  /* ปรับขนาดวงกลม */
  height: 16px;
}

.small-radio .v-input--selection-controls__ripple,
.small-radio .v-input--selection-controls__input {
  width: 16px;
  /* ปรับขนาดวงกลม */
  height: 16px;
}

.decision-box {
  border: 1px solid #d1d5db;
  /* ขอบเทาอ่อน */
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  margin-bottom: 12px;
}

.box-title {
  font-size: 14px;
  font-weight: 600;
}

.box-label {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 4px;
  display: block;
}

.hidden-input {
  display: none;
}
</style>
